import React, { useEffect, useState, useRef } from "react";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  dotNumberValidation,
  dotNumberBlurValidation,
  withDotValidation,
} from "../../../../../../helpers/global_helper";
import BetSuccessPopup from "../../../../../Popups/BetSuccessPopup";
import ConfirmBetDeskonPopup from "../../../../../Popups/ConfirmBetDeskonPopup";
import { useSelector, useDispatch } from "react-redux";
import ErrorPopup from "../../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../../Popups/ErrorInnerPopup";
import ConfirmDataBetDeskonPopup from "../../../../../Popups/ConfirmDataBetDeskonPopup";
import { FaBullseye, FaLeaf } from "react-icons/fa";
import CancelledBetDeskonPopup from "../../../../../Popups/CancelledBetDeskonPopup";
import { withTranslation } from "react-i18next";
import { formatPrice } from "../../../../../NumberFormat";
import TableCount from "../TableCount";
import {
  getUserBalance,
  setCommonConfig,
} from "../../../../../../redux/actions";
import GameClosedPopup from "../../../GameClosedPopup";
import MarketClose from "../../../MarketClose";
import { mobileTotalBetCalculate } from "../MobileTotalBetCalcy";
import CommonBetHeader from "../../../CommonBetHeader";
import { MdKeyboardArrowRight } from "react-icons/md";
import { TbBulb } from "react-icons/tb";
import CoachMarkPopup from "../../../../../Popups/CoachMarkPopup";

const Bet_Diskon = (props) => {
  const totaldiv = useRef();
  const guessRef = useRef(null);
  const autoBetRef = useRef(null);
  const bbRef = useRef(null);
  const resetRef = useRef(null);
  const dispatch = useDispatch();
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const user_balance = useSelector((state) => state.UserBalance.user_balance);
  const [dicountValue, setDiscountValue] = useState();
  const [maxAmountValue, setMaxtAmountValue] = useState();
  const [minAmountValue, setMinAmountValue] = useState();
  const [rowsToShow, setRowsToShow] = useState(0);
  const [successPopup, setSuccessPopup] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showCancelledPopup, setShowCancelledPopup] = useState(false);
  const [showConfirmationDataPopup, setShowConfirmationDataPopup] =
    useState(false);
  const [inputToShow, setInputToShow] = useState(4);
  const [respData, setRespData] = useState([]);
  const [values, setValues] = useState([]);
  const [angaka, setAngaka] = useState([]);
  const [angakaBB, setAngakaBB] = useState([]);
  const [rowInd, setRowInd] = useState(0);
  const [newIndexFocus, setNewIndexFocus] = useState("");
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [isPopupShown, setIsPopupShown] = useState(false);
  const initialAngaka = {
    isfullbet: null,
    gameId: null,
    gameType: "4d3d2d",
    dfp: "diskon",
    action: "process",
    betTogelAuth: "betTogelAuth",
    allowPartner: "allowPartner",
    dataangka: [],
  };
  const [reqData, setReqData] = useState(initialAngaka);
  const [newAngakaD, setNewAngakaD] = useState([]);
  const [newReqData, setNewReqData] = useState(initialAngaka);
  const [reqBBData, setReqBBData] = useState(initialAngaka);

  const colRef = useRef({});
  const [bets, setBets] = useState({});
  const [belliBets, setBelliBets] = useState({});
  const [diskon, setDiskon] = useState({});
  const [bolakBalik, setBolakBalik] = useState({});
  const [belli, setBbelli] = useState({});
  const [probabilityTable, setProbabilityTable] = useState(false);
  const [mainButton, setMainButton] = useState(true);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [succMessage, setSuccessMessage] = useState("");
  const [bolBalikRow, setBolBalikRow] = useState([]);
  const [bolBalikRowALL, setBolBalikRowAll] = useState(0);
  const [bolakBalikRespArray, setBolakBalikRespArray] = useState([]);
  const [checkedBoxes, setCheckedBoxes] = useState(
    Array(bolakBalikRespArray.length).fill(true)
  );
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalBetAmount, setTotalBetAmount] = useState([]);
  const [bbPayAmount, setBBPayAmount] = useState(0);
  const [payAmount, setPayAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [mobMaxValidate, setMobMaxValidate] = useState(0);
  const [bolakBalikRespAngka, setBolakBalikRespAngka] = useState([]);
  const [defaultValue, setDefaultvalue] = useState("");
  const [defaultValue3D, setDefaultvalue3D] = useState("");
  const [defaultValue2D, setDefaultvalue2D] = useState("");
  const [mobile4Digit, setMobile4Digit] = useState(0);
  const [betLength, setBetLength] = useState(0);
  const currentStep = useSelector((state) => state.paginationData.currentStep)

  const [beliDisabled, setBeliDisabled] = useState(
    Array(rowsToShow).fill(true)
  );
  const [beliDisabled3D, setBeliDisabled3D] = useState(
    Array(rowsToShow).fill(true)
  );
  const [beliDisabled2D, setBeliDisabled2D] = useState(
    Array(rowsToShow).fill(true)
  );
  // Mobie Usestate ============
  const [mobbets, setMobBets] = useState({});

  useEffect(()=>{
 if((device === "Mobile" || device === "Desktop" || device === "Tablet") && currentStep === 2 &&
    guessRef.current){
      const highlightedElement = guessRef.current.querySelector(".highlighted");
      highlightedElement.scrollIntoView({ behavior: "smooth", block: device === "Mobile" ? "center": "start", top: 80 });
    }
  },[currentStep, device])
 
// == Try
// useEffect(() => {
  // if ((device === "Mobile" || device === "Desktop" || device === "Tablet") &&
  //   currentStep === 2 &&
  //   guessRef.current) {

  //   const highlightedElement = guessRef.current.querySelector(".highlighted");

  //   if (highlightedElement) {
  //     const topOffset = highlightedElement.getBoundingClientRect().top + window.pageYOffset;

  //     // scroll higher than the element to show the tooltip above it
  //     const scrollOffset = device === "Mobile" ? 120 : 90;

  //     window.scrollTo({
  //       top: topOffset - scrollOffset,
  //       behavior: "smooth"
  //     });
  //   }
  // }
// }, [currentStep, device]);

// useEffect(() => {
//   if (
//     (device === "Mobile" || device === "Tablet" || device === "Desktop") &&
//     currentStep === 2 &&
//     guessRef.current
//   ) {
//     const highlightedElement = guessRef.current.querySelector(".highlighted");

//     if (highlightedElement) {
//       setTimeout(() => {
//         const topOffset = highlightedElement.getBoundingClientRect().top + window.pageYOffset;
//         const scrollOffset = device === "Mobile" ? 240 : 100;

//         window.scrollTo({
//           top: topOffset - scrollOffset,
//           behavior: "smooth",
//         });
//       }, 150); // ✅ Slight delay to allow tooltip to fully render
//     }
//   }
// }, [currentStep, device]);

// == Try

  useEffect(() => {
    const rowCount = device === "Desktop" ? 10 : 10;
    setRowsToShow(rowCount);
  }, [device]);

  useEffect(() => {
    // if ((device === "Mobile" || device === "Desktop" || device === "Tablet") && (currentStep === 2 || currentStep === 3 ||currentStep === 6 || currentStep === 7)) {
      if ((device === "Mobile" || device === "Desktop" || device === "Tablet") && ( currentStep === 6 || currentStep === 7)&&
      resetRef.current) {
      resetRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
    // else if((device === "Mobile" || device === "Desktop" || device === "Tablet") && currentStep === 2 &&
    // guessRef.current){
    //   guessRef.current.scrollIntoView({
    //     behavior: "smooth",
    //     block: "center",
    //   });
    // }
    else if((device === "Mobile" || device === "Desktop" || device === "Tablet") && (currentStep === 4 || currentStep === 3)&&
    bbRef.current){
      bbRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [currentStep, device]);

  const handleInputBlur = (e, rowIndex, inputInd) => {
    const { name, value } = e.target;
    if (device === "Desktop") {
      updateBetNumber();
      let updatedBets = { ...bets };
      let bet = updatedBets[`bets${rowIndex}`];

      // if (inputInd > 0 && value !== "") {
      //   for (let j = 0; j < inputInd; j++) {
      //     const prevInputName = `bets${rowIndex}${j}`;
      //     if (!updatedBets[prevInputName]) {
      //       updatedBets[prevInputName] = "X";
      //     }
      //   }
      //   updatedBets[name] = value || "X";
      //   setBets(updatedBets);
      // }
      // if (
      //   inputInd === 2 &&
      //   value === "" &&
      //   updatedBets[`bets${rowIndex}0`] !== "" &&
      //   updatedBets[`bets${rowIndex}0`] !== undefined &&
      //   updatedBets[`bets${rowIndex}1`] !== "" &&
      //   updatedBets[`bets${rowIndex}1`] !== undefined &&
      //   updatedBets[`bets${rowIndex}2`] === undefined
      // ) {
      //   setBets({
      //     ...updatedBets,
      //     [name]: value || "X",
      //     [`bets[${rowIndex}3]`]: "X",
      //   });
      //   const newIndex = `${rowIndex}-belli`;
      //   colRef.current[newIndex].focus();
      // }
      // if (
      //   inputInd === 3 &&
      //   updatedBets[`bets${rowIndex}0`] !== "" &&
      //   updatedBets[`bets${rowIndex}0`] !== undefined &&
      //   updatedBets[`bets${rowIndex}1`] !== "" &&
      //   updatedBets[`bets${rowIndex}1`] !== undefined &&
      //   updatedBets[`bets${rowIndex}2`] !== "" &&
      //   updatedBets[`bets${rowIndex}2`] !== undefined
      // ) {
      //   setBets({
      //     ...updatedBets,
      //     [name]: value || "X",
      //   });
      // }
      // if (
      //   inputInd === 0 &&
      //   value === "" &&
      //   updatedBets[`bets${rowIndex}1`] !== "" &&
      //   updatedBets[`bets${rowIndex}2`] !== "" &&
      //   updatedBets[`bets${rowIndex}3`] !== "" &&
      //   updatedBets[`bets${rowIndex}1`] !== undefined &&
      //   updatedBets[`bets${rowIndex}2`] !== undefined &&
      //   updatedBets[`bets${rowIndex}3`] !== undefined
      // ) {
      //   setBets({
      //     ...updatedBets,
      //     [name]: value || "X",
      //   });
      //   const newIndex = `${rowIndex}-belli`;
      //   colRef.current[newIndex].focus();
      // }
      // if (
      //   inputInd === 1 &&
      //   value === "" &&
      //   updatedBets[`bets${rowIndex}0`] !== "" &&
      //   updatedBets[`bets${rowIndex}2`] !== "" &&
      //   updatedBets[`bets${rowIndex}3`] !== "" &&
      //   updatedBets[`bets${rowIndex}0`] !== undefined &&
      //   updatedBets[`bets${rowIndex}2`] !== undefined &&
      //   updatedBets[`bets${rowIndex}3`] !== undefined
      // ) {
      //   setBets({
      //     ...updatedBets,
      //     [name]: value || "X",
      //   });
      //   const newIndex = `${rowIndex}-belli`;
      //   colRef.current[newIndex].focus();
      // }
      if (bet !== undefined) {
        if (bet.length === 3) {
          const newIndex = `3D-${rowIndex}`;
          colRef.current[newIndex].focus();
        }
        if (bet.length === 2) {
          const newIndex = `2D-${rowIndex}-Blkg`;
          colRef.current[newIndex].focus();
        }
      }
    } else {
      updateMobileBets();
      if (value.length >= 2) {
        const newIndex = `${rowIndex}-belli`;
        colRef.current[newIndex].focus();
      }
    }
  };

  const hendleInputFocus = (e, rowIndex, inputIndex) => {
    const { name, value } = e.target;
    let updatedBets = { ...bets };
    if (
      (updatedBets[`bets${rowIndex}0`] !== "" &&
        updatedBets[`bets${rowIndex}0`] !== undefined &&
        updatedBets[`bets${rowIndex}1`] !== "" &&
        updatedBets[`bets${rowIndex}1`] !== undefined &&
        updatedBets[`bets${rowIndex}2`] === "") ||
      (updatedBets[`bets${rowIndex}2`] === undefined &&
        updatedBets[`bets${rowIndex}3`] === "" &&
        updatedBets[`bets${rowIndex}3`] === undefined &&
        rowIndex !== rowInd &&
        inputIndex === 3)
    ) {
      if (
        updatedBets[`bets${rowIndex}0`] !== "" &&
        updatedBets[`bets${rowIndex}1`] !== "" &&
        updatedBets[`bets${rowIndex}2`] !== ""
      ) {
        const newIndex = `${rowIndex}-belli`;
        colRef.current[newIndex].focus();
      }
    }
  };

  const handleInputChange = (e, rowIndex, inputInd, columnName) => {
    setRowInd(rowIndex);
    const { name, value } = e.target;
    const onlyNumbers = value.replace(/[^0-9]/g, "")
      ? value.replace(/[^0-9]/g, "")
      : "";
    const onlyNumbersMob = value.replace(/[^0-9]/g, "")
      ? value.replace(/[^0-9]/g, "")
      : "";
    let prevLength =
      device === "Desktop" ? onlyNumbers.length : onlyNumbersMob.length;
    if (onlyNumbers.length > 3 || onlyNumbersMob.length > 3) {
      setBetLength(
        device === "Desktop" ? onlyNumbers.length : onlyNumbersMob.length
      );
    }

    resetRowDataNoValue(rowIndex, prevLength);

    if (device === "Desktop") {
      let updatedBets = { ...bets };
      updatedBets[name] = onlyNumbers;
      setBets(updatedBets);
      setMobMaxValidate(0);
      mobileValidation(onlyNumbers, rowIndex, value);
    } else {
      setMobile4Digit(0); // it is use for 4th digit update in values array true = update, false = notupdate
      setMobMaxValidate(0);
      const newMobBets = {
        ...mobbets,
        [name]: onlyNumbersMob,
      };
      setMobBets(newMobBets);
      mobileValidation(onlyNumbersMob, rowIndex, value);
    }

    const updateDisabledValues = (
      beliDisabledArray,
      lengthCondition,
      rowIndex
    ) => {
      return beliDisabledArray.map((item, ind) => {
        if (ind === rowIndex) {
          if (
            (item === true && onlyNumbersMob.length >= lengthCondition) ||
            (item === false && onlyNumbersMob.length < lengthCondition)
          ) {
            return !item; // Toggle the item
          }
        }
        return item; // No changes for other rows
      });
    };

    if (onlyNumbersMob.length === 4) {
      const newDisabledVal = updateDisabledValues(beliDisabled, 2, rowIndex);
      setBeliDisabled(newDisabledVal);
    } else if (onlyNumbersMob.length === 3) {
      setBeliDisabled([
        ...beliDisabled.slice(0, rowIndex),
        true, // Disable this specific row
        ...beliDisabled.slice(rowIndex + 1),
      ]);
      const newDisabledVal3D = updateDisabledValues(
        beliDisabled3D,
        3,
        rowIndex
      );
      setBeliDisabled3D(newDisabledVal3D);
    } else if (onlyNumbersMob.length === 2) {
      setBeliDisabled3D([
        ...beliDisabled3D.slice(0, rowIndex),
        true, // Disable this specific row
        ...beliDisabled3D.slice(rowIndex + 1),
      ]);
      const newDisabledVal2D = updateDisabledValues(
        beliDisabled2D,
        2,
        rowIndex
      );
      setBeliDisabled2D(newDisabledVal2D);
    } else {
      setBeliDisabled2D([
        ...beliDisabled2D.slice(0, rowIndex),
        true, // Disable this specific row
        ...beliDisabled2D.slice(rowIndex + 1),
      ]);
    }

    if (onlyNumbersMob.length == 4 || onlyNumbers.length == 4) {
      const newIndex = `${rowIndex}-belli`;
      setTimeout(() => {
        colRef.current[newIndex].focus();
      }, 0);
    }
  };

  const resetRowDataNoValue = (rowIndex, length) => {
    if (length == 2 && betLength == 4) {
      setBeliDisabled((prevBeliDis) => {
        const newBeliDisabled = [...prevBeliDis];
        newBeliDisabled[rowIndex] = true;
        return newBeliDisabled;
      });
      const newBelliBets = { ...belliBets };
      delete newBelliBets[`4D-${rowIndex}`]; // or whichever key you want
      delete newBelliBets[`3D-${rowIndex}`]; // or whichever key you want
      setBelliBets(newBelliBets);
    } else if (length == 0 || (length == 1 && betLength == 4)) {
      setValues((prevVal) => {
        const newValues = [...prevVal];
        newValues[rowIndex] = undefined;
        return newValues;
      });

      setBeliDisabled((prevBeliDis) => {
        const newBeliDisabled = [...prevBeliDis];
        newBeliDisabled[rowIndex] = true;
        return newBeliDisabled;
      });

      setBeliDisabled3D((prevBeliDis3D) => {
        const newBeliDisabled3D = [...prevBeliDis3D];
        newBeliDisabled3D[rowIndex] = true;
        return newBeliDisabled3D;
      });
      const newBelliBets = { ...belliBets };
      delete newBelliBets[`4D-${rowIndex}`]; // or whichever key you want
      delete newBelliBets[`3D-${rowIndex}`]; // or whichever key you want
      delete newBelliBets[`2D-${rowIndex}`]; // or whichever key you want
      setBelliBets(newBelliBets);
    } else if (length == 4 && betLength == 4) {
      setBeliDisabled((prevBeliDis) => {
        const newBeliDisabled = [...prevBeliDis];
        newBeliDisabled[rowIndex] = false;
        return newBeliDisabled;
      });

      setBeliDisabled3D((prevBeliDis3D) => {
        const newBeliDisabled3D = [...prevBeliDis3D];
        newBeliDisabled3D[rowIndex] = false;
        return newBeliDisabled3D;
      });

      setBeliDisabled2D((prevBeliDis2D) => {
        const newBeliDisabled2D = [...prevBeliDis2D];
        newBeliDisabled2D[rowIndex] = false;
        return newBeliDisabled2D;
      });
      setBelliBets((prevBelli) => {
        const newBelliBets = { ...prevBelli };
        newBelliBets[`4D-${rowIndex}`] = defaultValue;
        newBelliBets[`3D-${rowIndex}`] = defaultValue3D;
        newBelliBets[`2D-${rowIndex}`] = defaultValue2D;
        return newBelliBets;
      });
    }
  };

  const mobileValidation = (bet, index, value) => {
    if (bet.length == 4) {
      if (defaultValue !== "" && defaultValue !== undefined) {
        if (defaultValue * betDiscount.showMultiple > betDiscount.showMax4d) {
          setBelliBets((prevBeli) => {
            const updateBelliBet = { ...prevBeli };
            updateBelliBet[`4D-${index}`] = "";
            return updateBelliBet;
          });
          setErrorMessage(props.t("you_have_reached_max_bet_value"));
          setShowErrorPopup(true);
          return;
        } else if (
          defaultValue * betDiscount.showMultiple <
          betDiscount.showMin4d
        ) {
          setBelliBets({
            ...belliBets,
            [`4D-${index}`]: "",
          });
          // localStorage.getItem("I18N_LANGUAGE") == "en"
          //   ? setErrorMessage(
          //     `Minimal bet 4D is 1`
          //   )
          //   : setErrorMessage(
          //     `Minimal taruhan 4D adalah 1`
          //   );
          // setShowErrorPopup(true);
          // return;
        } else {
          let newDiskon3D;
          let value3D = defaultValue;
          newDiskon3D =
            value3D > 0
              ? (value3D * betDiscount.showMultiple * betDiscount.showDisc4d) /
              100
              : 0;

          let newBolakBalik;
          newBolakBalik = value3D * betDiscount.showMultiple - newDiskon3D;
          setBolakBalik({
            ...bolakBalik,
            [index]: newBolakBalik,
          });
          setBelliBets({
            ...belliBets,
            [`4D-${index}`]: defaultValue,
          });
        }
      }
    } else if (bet.length == 3) {
      if (
        defaultValue !== "" &&
        defaultValue !== undefined &&
        belliBets[`4D-${index}`]
      ) {
        setBelliBets({
          ...belliBets,
          [`4D-${index}`]: "",
        });
      }
      if (defaultValue3D !== "" && defaultValue3D !== undefined) {
        if (
          defaultValue3D * betDiscount.showMultiple >
          betDiscount.showMax3dBelakang
        ) {
          setBelliBets({
            ...belliBets,
            [`3D-${index}`]: "",
          });
          setErrorMessage(props.t("you_have_reached_max_bet_value"));
          setShowErrorPopup(true);
          return;
        } else if (
          defaultValue3D * betDiscount.showMultiple <
          betDiscount.showMin3dBelakang
        ) {
          setBelliBets({
            ...belliBets,
            [`3D-${index}`]: "",
          });
          // localStorage.getItem("I18N_LANGUAGE") == "en"
          //   ? setErrorMessage(
          //     `Minimal bet 3D is 1`
          //   )
          //   : setErrorMessage(
          //     `Minimal taruhan 3D adalah 1`
          //   );
          // setShowErrorPopup(true);
          // return;
        } else {
          let newDiskon3D;
          let value3D = defaultValue3D;
          newDiskon3D =
            value3D > 0
              ? (value3D * betDiscount.showMultiple * betDiscount.showDisc3d) /
              100
              : 0;

          let newBolakBalik;
          newBolakBalik = value3D * betDiscount.showMultiple - newDiskon3D;
          setBolakBalik({
            ...bolakBalik,
            [index]: newBolakBalik,
          });
          setBelliBets({
            ...belliBets,
            [`3D-${index}`]: defaultValue3D,
          });
        }
      }
    } else if (bet.length == 2) {
      if (
        defaultValue3D !== "" &&
        defaultValue3D !== undefined &&
        belliBets[`3D-${index}`]
      ) {
        setBelliBets({
          ...belliBets,
          [`3D-${index}`]: "",
        });
      }
      if (defaultValue2D !== "" && defaultValue2D !== undefined) {
        if (
          parseInt(defaultValue2D) * parseInt(betDiscount.showMultiple) >
          parseInt(betDiscount.showMax2dBelakang)
        ) {
          setBelliBets({
            ...belliBets,
            [`2D-${index}`]: "",
          });
          setErrorMessage(props.t("you_have_reached_max_bet_value"));
          setShowErrorPopup(true);
          return;
        } else {
          let newDiskon2D;
          let value2D = parseInt(defaultValue2D);
          newDiskon2D =
            value2D > 0
              ? (value2D *
                parseInt(betDiscount.showMultiple) *
                parseInt(betDiscount.showDisc2d)) /
              100
              : 0;

          let newBolakBalik;
          newBolakBalik =
            value2D * parseInt(betDiscount.showMultiple) - newDiskon2D;
          setBolakBalik({
            ...bolakBalik,
            [index]: newBolakBalik,
          });
          setBelliBets({
            ...belliBets,
            [`2D-${index}`]: defaultValue2D,
          });
        }
      }
    }
  };

  useEffect(() => {
    if (newIndexFocus) {
      colRef.current[newIndexFocus].focus();
    }
  }, [newIndexFocus]);

  const updateBetNumber = () => {
    let newValue = [...values];
    let betVal = "";
    let allBetsFilled = true;
    // Check if all bet values for the current row are not empty and defined
    // for (let k = 0; k < 4; k++) {
    //   if (
    //     typeof bets["bets" + rowInd + "" + k] === undefined ||
    //     bets["bets" + rowInd + "" + k] === "" ||
    //     bets["bets" + rowInd + "" + k] === undefined
    //   ) {
    //     allBetsFilled = false;
    //     break;
    //   }
    // }
    // if (allBetsFilled) {
    //   for (let k = 0; k < 4; k++) {
    //     betVal += bets["bets" + rowInd + "" + k];
    //   }
    //   let splitVal = betVal.split("");
    //   let conditionMet = false;
    //   if (
    //     (splitVal[0] !== "X" &&
    //       splitVal[1] === "X" &&
    //       splitVal[2] !== "X" &&
    //       splitVal[3] !== "X") ||
    //     (splitVal[0] !== "X" &&
    //       splitVal[1] !== "X" &&
    //       splitVal[2] === "X" &&
    //       splitVal[3] !== "X") ||
    //     (splitVal[0] === "X" &&
    //       splitVal[1] !== "X" &&
    //       splitVal[2] === "X" &&
    //       splitVal[3] !== "X") ||
    //     (splitVal[0] !== "X" &&
    //       splitVal[1] === "X" &&
    //       splitVal[2] !== "X" &&
    //       splitVal[3] === "X") ||
    //     (splitVal[0] !== "X" &&
    //       splitVal[1] === "X" &&
    //       splitVal[2] === "X" &&
    //       splitVal[3] !== "X") ||
    //     (splitVal[0] === "X" &&
    //       splitVal[1] !== "X" &&
    //       splitVal[2] === "X" &&
    //       splitVal[3] === "X") ||
    //     (splitVal[0] === "X" &&
    //       splitVal[1] === "X" &&
    //       splitVal[2] === "X" &&
    //       splitVal[3] !== "X") ||
    //     (splitVal[0] === "X" &&
    //       splitVal[1] === "X" &&
    //       splitVal[2] !== "X" &&
    //       splitVal[3] === "X") ||
    //     (splitVal[0] !== "X" &&
    //       splitVal[1] === "X" &&
    //       splitVal[2] === "X" &&
    //       splitVal[3] === "X")
    //   ) {
    //     conditionMet = true;
    //   }

    //   if (conditionMet) {
    //     newValue[rowInd] = undefined; // Remove the value at the specified rowInd
    //   } else {
    //     newValue[rowInd] = betVal; // Update the value at the specified rowInd
    //   }
    //   setValues(newValue);
    // }

    if (typeof bets["bets" + rowInd] != "undefined") {
      if (bets["bets" + rowInd] != "" && bets["bets" + rowInd].length >= 2) {
        newValue[rowInd] = bets["bets" + rowInd];
      } else {
        if (bets["bets" + rowInd]) {
          newValue[rowInd] = undefined;
        }
      }
    }
    setValues(newValue);
  };

  useEffect(() => {
    updateBetNumber();
  }, [bets, belliBets]);

  const updateMobileBets = () => {
    let newValue = [...values];
    if (typeof mobbets["mobbets" + rowInd] != "undefined") {
      if (
        mobbets["mobbets" + rowInd] != "" &&
        mobbets["mobbets" + rowInd].length >= 2
      ) {
        newValue[rowInd] = mobbets["mobbets" + rowInd];
      } else {
        if (mobbets["mobbets" + rowInd]) {
          newValue[rowInd] = undefined;
        }
      }
    }
    setValues(newValue);
  };

  useEffect(() => {
    updateMobileBets();
  }, [mobbets, belliBets, mobile4Digit]);


  const handleFocusInput = (e, rowIndex, type) => {
    setRowInd(rowIndex);
    updateBetNumber();
    updateMobileBets();
    const { name, value } = e.target;
    if (value === "") {
      if (defaultValue && type == "4D") {
        setBelliBets((prevBelli) => ({
          ...prevBelli,
          [name]: defaultValue,
        }));
      } else if (defaultValue3D && type == "3D") {
        setBelliBets((prevBelli) => ({
          ...prevBelli,
          [name]: defaultValue3D,
        }));
      } else if (defaultValue2D && type == "2D") {
        setBelliBets((prevBelli) => ({
          ...prevBelli,
          [name]: defaultValue2D,
        }));
      }
    }
    let newBets = { ...bets };
    if (
      newBets[`bets${rowIndex}0`] !== "" &&
      newBets[`bets${rowIndex}1`] !== "" &&
      newBets[`bets${rowIndex}2`] === undefined &&
      newBets[`bets${rowIndex}3`] === undefined
    ) {
      newBets[`bets${rowIndex}2`] = "";
      newBets[`bets${rowIndex}3`] = "";
      setBets(newBets);
    }
    setMobMaxValidate(1);
  };

  useEffect(() => {
    let discountVal = "";
    let maxAmount = "";
    let minAmount = "";
    if (device === "Desktop") {
      let newValuesD = "";
      let checkValidationVal = "";
      for (let k = 0; k < 4; k++) {
        if (bets["bets" + rowInd + "" + k] != "X") {
          newValuesD = newValuesD + bets["bets" + rowInd + "" + k];
        }
        checkValidationVal =
          checkValidationVal +
          (bets["bets" + rowInd + "" + k] !== ""
            ? bets["bets" + rowInd + "" + k]
            : "X");
      }

      let expCheckVal = checkValidationVal.split("");

      if (newValuesD.length == 2) {
        if (
          expCheckVal[0] != "X" &&
          expCheckVal[1] != "X" &&
          expCheckVal[2] == "X" &&
          expCheckVal[3] == "X"
        ) {
          maxAmount = betDiscount.showMax2dDepan;
          minAmount = betDiscount.showMin2dDepan;
        } else if (
          expCheckVal[0] == "X" &&
          expCheckVal[1] != "X" &&
          expCheckVal[2] != "X" &&
          expCheckVal[3] == "X"
        ) {
          maxAmount = betDiscount.showMax2dTengah;
          minAmount = betDiscount.showMin2dTengah;
        } else if (
          expCheckVal[0] == "X" &&
          expCheckVal[1] == "X" &&
          expCheckVal[2] != "X" &&
          expCheckVal[3] != "X"
        ) {
          maxAmount = betDiscount.showMax2dBelakang;
          minAmount = betDiscount.showMin2dBelakang;
        }
        discountVal = betDiscount.showDisc2d;
      } else if (newValuesD.length == 3) {
        if (
          expCheckVal[0] != "X" &&
          expCheckVal[1] != "X" &&
          expCheckVal[2] != "X" &&
          expCheckVal[3] == "X"
        ) {
          maxAmount = betDiscount.showMax3dDepan;
          minAmount = betDiscount.showMin3dDepan;
        } else if (
          expCheckVal[0] == "X" &&
          expCheckVal[1] != "X" &&
          expCheckVal[2] != "X" &&
          expCheckVal[3] != "X"
        ) {
          maxAmount = betDiscount.showMax3dBelakang;
          minAmount = betDiscount.showMin3dBelakang;
        }
        discountVal = betDiscount.showDisc3d;
      } else if (newValuesD.length == 4) {
        maxAmount = betDiscount.showMax4d;
        minAmount = betDiscount.showMin4d;
        discountVal = betDiscount.showDisc4d;
      } else {
        //
      }
      let newMaxAmount;
      if (betDiscount.userBetLimitPerc) {
        newMaxAmount =
          (maxAmount * betDiscount.userBetLimitPerc.tg_limit_percent) / 100;
      }
      setMaxtAmountValue(newMaxAmount);
      setMinAmountValue(minAmount);
      setDiscountValue(discountVal);
    }
  }, [bets, belliBets]);

  useEffect(() => {
    if (device === "Desktop") {
      if (
        defaultValue !== "" &&
        belliBets[rowInd] !== "" &&
        belliBets[rowInd] != undefined
      ) {
        if (
          values[rowInd] !== undefined &&
          mobMaxValidate > 0 &&
          maxAmountValue > 0
        ) {
          if (belliBets[rowInd] * betDiscount.showMultiple > maxAmountValue) {
            setBelliBets({
              ...belliBets,
              [rowInd]: "",
            });
            setBbelli((prevBelli) => ({
              ...prevBelli,
              [rowInd]: "",
            }));
            setBolakBalik({
              ...bolakBalik,
              [rowInd]: "",
            });

            setDiskon({
              ...diskon,
              [rowInd]: "",
            });
            setErrorMessage(props.t("you_have_reached_max_bet_value"));
            setShowErrorPopup(true);
          } else if (

            belliBets[rowInd] * betDiscount.showMultiple <
            minAmountValue
          ) {
            setBelliBets({
              ...belliBets,
              [rowInd]: "",
            });
            setBbelli((prevBelli) => ({
              ...prevBelli,
              [rowInd]: "",
            }));
            setBolakBalik({
              ...bolakBalik,
              [rowInd]: "",
            });

            setDiskon({
              ...diskon,
              [rowInd]: "",
            });
            localStorage.getItem("I18N_LANGUAGE") == "en"
              ? setErrorMessage(
                `Minimal bet ${values[rowInd].split("").filter((item) => item !== "X")
                  .length + "D"
                } is 1`
              )
              : setErrorMessage(
                `Minimal taruhan ${values[rowInd].split("").filter((item) => item !== "X")
                  .length + "D"
                } adalah 1`
              );
            setShowErrorPopup(true);
          } else {
            let value = belliBets[rowInd]
              ? belliBets[rowInd]
              : parseInt(defaultValue);
            const newDiskon =
              (value * betDiscount.showMultiple * dicountValue) / 100;
            const newBolakBalik = value * betDiscount.showMultiple - newDiskon;
            setBbelli((prevBelli) => ({
              ...prevBelli,
              [rowInd]: parseInt(value) * betDiscount.showMultiple,
            }));
            setBolakBalik((prevBolakBalik) => ({
              ...prevBolakBalik,
              [rowInd]: newBolakBalik,
            }));
            setDiskon((prevDiskon) => ({
              ...prevDiskon,
              [rowInd]: newDiskon,
            }));
          }
        } else {
          if (dicountValue === 0 && belliBets[rowInd] !== "") {
            setBelliBets({
              ...belliBets,
              [rowInd]: "",
            });
            // localStorage.getItem("I18N_LANGUAGE") == "en"
            //   ? setErrorMessage(`Minimal bet 4D is 1`)
            //   : setErrorMessage(`Minimal taruhan 4D adalah 1`);
            // setShowErrorPopup(true);
          }
        }
      }
    } else {
      if (
        (defaultValue !== "" &&
          belliBets[`4D-${rowInd}`] !== "" &&
          belliBets[`4D-${rowInd}`] !== undefined) ||
        (defaultValue3D !== "" &&
          belliBets[`3D-${rowInd}`] !== "" &&
          belliBets[`3D-${rowInd}`] !== undefined) ||
        (defaultValue2D !== "" &&
          belliBets[`2D-${rowInd}`] !== "" &&
          belliBets[`2D-${rowInd}`] !== undefined)
      ) {
        let max4DValue;
        let max3DValue;
        let max2DValue;
        if (
          belliBets[`4D-${rowInd}`] &&
          belliBets[`4D-${rowInd}`] !== undefined
        ) {
          max4DValue = belliBets[`4D-${rowInd}`] * betDiscount.showMultiple;
        }
        if (
          belliBets[`3D-${rowInd}`] &&
          belliBets[`3D-${rowInd}`] !== undefined
        ) {
          max3DValue = belliBets[`3D-${rowInd}`] * betDiscount.showMultiple;
        }
        if (
          belliBets[`2D-${rowInd}`] &&
          belliBets[`2D-${rowInd}`] !== undefined
        ) {
          max2DValue = belliBets[`2D-${rowInd}`] * betDiscount.showMultiple;
        }
        if (
          mobbets["mobbets" + rowInd] !== undefined &&
          mobMaxValidate > 0 &&
          maxAmountValue > 0
        ) {
          if (max4DValue && max4DValue > betDiscount.showMax4d) {
            setBelliBets({
              ...belliBets,
              [`4D-${rowInd}`]: "",
            });
            setBbelli((prevBelli) => ({
              ...prevBelli,
              [rowInd]: "",
            }));
            setBolakBalik({
              ...bolakBalik,
              [rowInd]: "",
            });

            setDiskon({
              ...diskon,
              [rowInd]: "",
            });
            setErrorMessage(props.t("you_have_reached_max_bet_value"));
            setShowErrorPopup(true);
          } else if (max3DValue && max3DValue > betDiscount.showMax3dBelakang) {
            setBelliBets({
              ...belliBets,
              [`3D-${rowInd}`]: "",
            });
            setBbelli((prevBelli) => ({
              ...prevBelli,
              [rowInd]: "",
            }));
            setBolakBalik({
              ...bolakBalik,
              [rowInd]: "",
            });

            setDiskon({
              ...diskon,
              [rowInd]: "",
            });
            setErrorMessage(props.t("you_have_reached_max_bet_value"));
            setShowErrorPopup(true);
          } else if (max2DValue && max2DValue > betDiscount.showMax2dBelakang) {
            setBelliBets({
              ...belliBets,
              [`2D-${rowInd}`]: "",
            });
            setBbelli((prevBelli) => ({
              ...prevBelli,
              [rowInd]: "",
            }));
            setBolakBalik({
              ...bolakBalik,
              [rowInd]: "",
            });

            setDiskon({
              ...diskon,
              [rowInd]: "",
            });
            setErrorMessage(props.t("you_have_reached_max_bet_value"));
            setShowErrorPopup(true);
          } else if (max4DValue && max4DValue < betDiscount.showMin4d) {
            setBelliBets({
              ...belliBets,
              [`4D-${rowInd}`]: "",
            });
            setBbelli((prevBelli) => ({
              ...prevBelli,
              [rowInd]: "",
            }));
            setBolakBalik({
              ...bolakBalik,
              [rowInd]: "",
            });

            setDiskon({
              ...diskon,
              [rowInd]: "",
            });
            // localStorage.getItem("I18N_LANGUAGE") == "en"
            //   ? setErrorMessage(
            //     'Minimal bet 4D is 1'
            //   )
            //   : setErrorMessage(
            //     'Minimal taruhan 4D adalah 1'
            //   );
            // setShowErrorPopup(true);
          } else if (max3DValue && max3DValue < betDiscount.showMin3dBelakang) {
            setBelliBets({
              ...belliBets,
              [`3D-${rowInd}`]: "",
            });
            setBbelli((prevBelli) => ({
              ...prevBelli,
              [rowInd]: "",
            }));
            setBolakBalik({
              ...bolakBalik,
              [rowInd]: "",
            });

            setDiskon({
              ...diskon,
              [rowInd]: "",
            });
            // localStorage.getItem("I18N_LANGUAGE") == "en"
            //   ? setErrorMessage(
            //     'Minimal bet 4D is 1'
            //   )
            //   : setErrorMessage(
            //     'Minimal taruhan 4D adalah 1'
            //   );
            // setShowErrorPopup(true);
          } else if (max2DValue && max2DValue < betDiscount.showMin2dBelakang) {
            setBelliBets({
              ...belliBets,
              [`4D-${rowInd}`]: "",
            });
            setBbelli((prevBelli) => ({
              ...prevBelli,
              [rowInd]: "",
            }));
            setBolakBalik({
              ...bolakBalik,
              [rowInd]: "",
            });

            setDiskon({
              ...diskon,
              [rowInd]: "",
            });
            // localStorage.getItem("I18N_LANGUAGE") == "en"
            //   ? setErrorMessage(
            //     'Minimal bet 4D is 1'
            //   )
            //   : setErrorMessage(
            //     'Minimal taruhan 4D adalah 1'
            //   );
            // setShowErrorPopup(true);
          } else {
            let value = belliBets[rowInd]
              ? belliBets[rowInd]
              : parseInt(defaultValue);
            const newDiskon =
              (value * betDiscount.showMultiple * dicountValue) / 100;
            const newBolakBalik = value * betDiscount.showMultiple - newDiskon;
            setBbelli((prevBelli) => ({
              ...prevBelli,
              [rowInd]: value * betDiscount.showMultiple,
            }));
            setBolakBalik((prevBolakBalik) => ({
              ...prevBolakBalik,
              [rowInd]: newBolakBalik,
            }));
            setDiskon((prevDiskon) => ({
              ...prevDiskon,
              [rowInd]: newDiskon ? newDiskon : "0",
            }));
          }
        }
      }
    }
  }, [belliBets, maxAmountValue]);


  const handleInputChangeBelli = (e, rowIndex, betname, betType) => {
    setRowInd(rowIndex);
    let { name, value } = e.target;
    value = value.replace(',', '.');
    console.log("value", value);
    
    let regex = '';
    if (betType == '4D') {
      if (String(betDiscount.showMin4d).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberValidation(value);
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
    } else if (betType == '3D') {
      if (String(betDiscount.showMin3dBelakang).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberValidation(value);
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
    } else if (betType == '2D') {
      if (String(betDiscount.showMin2dBelakang).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberValidation(value);
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
    }

    if (regex.test(value)) {
      setBelliBets({
        ...belliBets,
        [name]: value,
      });

      if (belli[rowIndex] && value == "") {
        const newBelli = { ...belli };
        delete newBelli[rowIndex];
        setBbelli(newBelli);
      } else {
        setBbelli({
          ...belli,
          [rowIndex]: value * betDiscount.showMultiple,
        });
      }
    }
  };

  const fixDecimal = value => {
    if (Array.isArray(value)) {
      return value.map(item => fixDecimal(item));
    }
    return !isNaN(value) ? parseFloat(parseFloat(value).toFixed(1)) : value;
  };

  useEffect(() => {
    let rowBet;
    if (device === "Desktop") {
      rowBet = bets["bets" + rowInd];
    } else {
      rowBet = mobbets["mobbets" + rowInd];
    }
    if (bolBalikRow.filter((item) => item !== undefined).length > 0) {
      let newTotalBetAmount = mobileTotalBetCalculate("4D3D2D", rowBet, belliBets, rowInd, betDiscount, true, bolBalikRow, bolBalikRowALL, values, "discount", device)

      if (device === "Desktop" && bolBalikRow.filter(item => item !== undefined).length > 0) {
        setBBPayAmount(fixDecimal(newTotalBetAmount[0]))
        setTotalBetAmount(fixDecimal(newTotalBetAmount[2]))
        setDiskon(fixDecimal(newTotalBetAmount[1]))
      }
      else {
        setTotalBetAmount(fixDecimal(newTotalBetAmount[0]))
        setDiskon(fixDecimal(newTotalBetAmount[1]))

      }
    }
    else {
      setBBPayAmount(0)
      let newTotalBetAmount = 0;
      const valBelli = Object.entries(belliBets).filter(
        ([key, value]) => value !== undefined && value !== ""
      );

      if (valBelli.length > 0) {
        newTotalBetAmount = totalBetAmount;
      } else {
        newTotalBetAmount = 0;
      }
      newTotalBetAmount = mobileTotalBetCalculate("4D3D2D", rowBet, belliBets, rowInd, betDiscount, false, bolBalikRow, bolBalikRowALL, values, "discount", device)
      
      if (device === "Desktop") {
        setTotalBetAmount(fixDecimal(newTotalBetAmount[1]))
        setDiskon(fixDecimal(newTotalBetAmount[2]))
      }
      else {
        setTotalBetAmount(fixDecimal(newTotalBetAmount[0]))
        setDiskon(fixDecimal(newTotalBetAmount[1]))
      }
    }
  }, [belliBets, values, bolBalikRow]);

  const handleBelliChangeBlur = (e, rowIndex, type) => {
    let { name, value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (type == '4D') {
      if (String(betDiscount.showMin4d).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberBlurValidation(value);
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
    } else if (type == '3D') {
      if (String(betDiscount.showMin3dBelakang).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberBlurValidation(value);
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
    } else if (type == '2D') {
      if (String(betDiscount.showMin2dBelakang).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
        value = dotNumberBlurValidation(value);
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
    }

    setMobile4Digit(1)
    updateBetNumber();
    let maxAmount = "";
    let minAmount = "";
    let maxAmount3D = "";
    let minAmount3D = "";
    let maxAmount2D = "";
    let minAmount2D = "";
    // if (device === "Desktop") {
    //   if (belliBets[rowIndex] !== "" && belliBets !== undefined) {
    //     let newValuesD = "";
    //     let checkValidationVal = "";
    //     for (let k = 0; k < 4; k++) {
    //       if (bets["bets" + rowInd + "" + k] !== "X") {
    //         newValuesD = newValuesD + bets["bets" + rowInd + "" + k];
    //       }
    //       checkValidationVal =
    //         checkValidationVal +
    //         (bets["bets" + rowInd + "" + k] !== ""
    //           ? bets["bets" + rowInd + "" + k]
    //           : "X");
    //     }
    //     let belliData = belliBets[rowInd] * betDiscount.showMultiple;

    //     let expCheckVal = checkValidationVal.split("");
    //     if (newValuesD.length === 2) {
    //       if (
    //         expCheckVal[0] !== "X" &&
    //         expCheckVal[1] !== "X" &&
    //         expCheckVal[2] === "X" &&
    //         expCheckVal[3] === "X"
    //       ) {
    //         maxAmount = betDiscount.showMax2dDepan;
    //         minAmount = betDiscount.showMin2dDepan;
    //       } else if (
    //         expCheckVal[0] === "X" &&
    //         expCheckVal[1] !== "X" &&
    //         expCheckVal[2] !== "X" &&
    //         expCheckVal[3] === "X"
    //       ) {
    //         maxAmount = betDiscount.showMax2dTengah;
    //         minAmount = betDiscount.showMin2dTengah;
    //       } else if (
    //         expCheckVal[0] === "X" &&
    //         expCheckVal[1] === "X" &&
    //         expCheckVal[2] !== "X" &&
    //         expCheckVal[3] !== "X"
    //       ) {
    //         maxAmount = betDiscount.showMax2dBelakang;
    //         minAmount = betDiscount.showMin2dBelakang;
    //       }
    //     } else if (newValuesD.length === 3) {
    //       if (
    //         expCheckVal[0] !== "X" &&
    //         expCheckVal[1] !== "X" &&
    //         expCheckVal[2] !== "X" &&
    //         expCheckVal[3] === "X"
    //       ) {
    //         maxAmount = betDiscount.showMax3dDepan;
    //         minAmount = betDiscount.showMin3dDepan;
    //       } else if (
    //         expCheckVal[0] === "X" &&
    //         expCheckVal[1] !== "X" &&
    //         expCheckVal[2] !== "X" &&
    //         expCheckVal[3] !== "X"
    //       ) {
    //         maxAmount = betDiscount.showMax3dBelakang;
    //         minAmount = betDiscount.showMin3dBelakang;
    //       }
    //     } else if (newValuesD.length === 4) {
    //       maxAmount = betDiscount.showMax4d;
    //       minAmount = betDiscount.showMin4d;
    //     } else {
    //       //
    //     }
    //     let newMaxAmount;
    //     if (betDiscount.userBetLimitPerc) {
    //       newMaxAmount =
    //         (maxAmount * betDiscount.userBetLimitPerc.tg_limit_percent) / 100;
    //     }
    //     if (belliData > newMaxAmount) {
    //       setBelliBets({
    //         ...belliBets,
    //         [rowInd]: "",
    //       });
    //       setBbelli((prevBelli) => ({
    //         ...prevBelli,
    //         [rowInd]: "",
    //       }));
    //       setBolakBalik({
    //         ...bolakBalik,
    //         [rowInd]: "",
    //       });
    //       setDiskon({
    //         ...diskon,
    //         [rowInd]: "",
    //       });
    //       setErrorMessage(props.t("you_have_reached_max_bet_value"));
    //       setShowErrorPopup(true);
    //     } else if (belliData < minAmount) {
    //       setBelliBets({
    //         ...belliBets,
    //         [rowInd]: "",
    //       });
    //       setBbelli((prevBelli) => ({
    //         ...prevBelli,
    //         [rowInd]: "",
    //       }));
    //       setBolakBalik({
    //         ...bolakBalik,
    //         [rowInd]: "",
    //       });
    //       setDiskon({
    //         ...diskon,
    //         [rowInd]: "",
    //       });
    //       localStorage.getItem("I18N_LANGUAGE") === "en"
    //         ? setErrorMessage(`Minimal bet ${newValuesD.length + "D"} is 1`)
    //         : setErrorMessage(
    //           `Minimal taruhan ${newValuesD.length + "D"} adalah 1`
    //         );
    //       setShowErrorPopup(true);
    //     } else if (betDiscount.showMultiple === 0) {
    //       setErrorMessage(props.t("you_have_reached_max_bet_value"));
    //       setShowErrorPopup(true);
    //     } else {
    //       let newDiskon;
    //       let value = belliBets[rowInd];
    //       newDiskon = (value * betDiscount.showMultiple * dicountValue) / 100;

    //       let newBolakBalik;
    //       newBolakBalik = value * betDiscount.showMultiple - newDiskon;

    //       setBolakBalik({
    //         ...bolakBalik,
    //         [rowInd]: newBolakBalik,
    //       });

    //       setDiskon({
    //         ...diskon,
    //         [rowInd]: newDiskon,
    //       });
    //     }
    //   } else {
    //     setBelliBets({
    //       ...belliBets,
    //       [rowIndex]: "",
    //     });
    //     setBbelli((prevBelli) => ({
    //       ...prevBelli,
    //       [rowIndex]: "",
    //     }));
    //     setBolakBalik({
    //       ...bolakBalik,
    //       [rowIndex]: "",
    //     });
    //     setDiskon({
    //       ...diskon,
    //       [rowIndex]: "",
    //     });
    //   }
    // } else {
    //   if (
    //     (mobbets["mobbets" + rowInd] !== undefined && belliBets[`4D-${rowInd}`] !== "" && belliBets[`4D-${rowInd}`] !== undefined) ||
    //     (mobbets["mobbets" + rowInd] !== undefined && belliBets[`3D-${rowInd}`] !== "" && belliBets[`3D-${rowInd}`] !== undefined) ||
    //     (mobbets["mobbets" + rowInd] !== undefined && belliBets[`2D-${rowInd}`] !== "" && belliBets[`2D-${rowInd}`] !== undefined)
    //   ) {
    //     let belliData = belliBets[`4D-${rowInd}`] * betDiscount.showMultiple;
    //     let belliData3D = belliBets[`3D-${rowInd}`] * betDiscount.showMultiple;
    //     let belliData2D = belliBets[`2D-${rowInd}`] * betDiscount.showMultiple;
    //     if (mobbets["mobbets" + rowInd].length === 2) {
    //       maxAmount2D = betDiscount.showMax2dDepan;
    //       minAmount2D = betDiscount.showMin2dDepan;
    //     } else if (mobbets["mobbets" + rowInd].length === 3) {
    //       maxAmount3D = betDiscount.showMax3dDepan;
    //       minAmount3D = betDiscount.showMin3dDepan;
    //       maxAmount2D = betDiscount.showMax2dDepan;
    //       minAmount2D = betDiscount.showMin2dDepan;
    //     } else if (mobbets["mobbets" + rowInd].length === 4) {
    //       maxAmount = betDiscount.showMax4d;
    //       minAmount = betDiscount.showMin4d;
    //       maxAmount3D = betDiscount.showMax3dDepan;
    //       minAmount3D = betDiscount.showMin3dDepan;
    //       maxAmount2D = betDiscount.showMax2dDepan;
    //       minAmount2D = betDiscount.showMin2dDepan;
    //     } else {
    //       //
    //     }
    //     let newMaxAmount;
    //     if (betDiscount.userBetLimitPerc) {
    //       newMaxAmount =
    //         (maxAmount * betDiscount.userBetLimitPerc.tg_limit_percent) / 100;
    //     }
    //     let newMaxAmount3D;
    //     if (betDiscount.userBetLimitPerc) {
    //       newMaxAmount3D =
    //         (maxAmount3D * betDiscount.userBetLimitPerc.tg_limit_percent) / 100;
    //     }
    //     let newMaxAmount2D;
    //     if (betDiscount.userBetLimitPerc) {
    //       newMaxAmount2D =
    //         (maxAmount2D * betDiscount.userBetLimitPerc.tg_limit_percent) / 100;
    //     }
    //     if (belliData > newMaxAmount) {
    //       setBelliBets({
    //         ...belliBets,
    //         [`4D-${rowInd}`]: "",
    //       });
    //       setBbelli((prevBelli) => ({
    //         ...prevBelli,
    //         [rowInd]: "",
    //       }));
    //       // setBolakBalik({
    //       //   ...bolakBalik,
    //       //   [rowInd]: "",
    //       // });
    //       setDiskon({
    //         ...diskon,
    //         [rowInd]: "",
    //       });
    //       setErrorMessage(props.t("you_have_reached_max_bet_value"));
    //       setShowErrorPopup(true);
    //       return;
    //     } else if (belliData3D > newMaxAmount3D) {
    //       setBelliBets({
    //         ...belliBets,
    //         [`3D-${rowInd}`]: "",
    //       });
    //       setBbelli((prevBelli) => ({
    //         ...prevBelli,
    //         [rowInd]: "",
    //       }));
    //       // setBolakBalik({
    //       //   ...bolakBalik,
    //       //   [rowInd]: "",
    //       // });
    //       setDiskon({
    //         ...diskon,
    //         [rowInd]: "",
    //       });
    //       setErrorMessage(props.t("you_have_reached_max_bet_value"));
    //       setShowErrorPopup(true);
    //       return;
    //     } else if (belliData2D > newMaxAmount2D) {
    //       setBelliBets({
    //         ...belliBets,
    //         [`2D-${rowInd}`]: "",
    //       });
    //       setBbelli((prevBelli) => ({
    //         ...prevBelli,
    //         [rowInd]: "",
    //       }));
    //       // setBolakBalik({
    //       //   ...bolakBalik,
    //       //   [rowInd]: "",
    //       // });
    //       setDiskon({
    //         ...diskon,
    //         [rowInd]: "",
    //       });
    //       setErrorMessage(props.t("you_have_reached_max_bet_value"));
    //       setShowErrorPopup(true);
    //       return;
    //     } else if (belliData < minAmount) {
    //       setBelliBets({
    //         ...belliBets,
    //         [`4D-${rowInd}`]: "",
    //       });
    //       setBbelli((prevBelli) => ({
    //         ...prevBelli,
    //         [rowInd]: "",
    //       }));
    //       // setBolakBalik({
    //       //   ...bolakBalik,
    //       //   [rowInd]: "",
    //       // });
    //       setDiskon({
    //         ...diskon,
    //         [rowInd]: "",
    //       });
    //       localStorage.getItem("I18N_LANGUAGE") == "en"
    //         ? setErrorMessage(
    //           `Minimal bet 4D is 1`
    //         )
    //         : setErrorMessage(
    //           `Minimal taruhan 4D adalah 1`
    //         );
    //       setShowErrorPopup(true);
    //     } else if (belliData3D < minAmount3D) {
    //       setBelliBets({
    //         ...belliBets,
    //         [`3D-${rowInd}`]: "",
    //       });
    //       setBbelli((prevBelli) => ({
    //         ...prevBelli,
    //         [rowInd]: "",
    //       }));
    //       // setBolakBalik({
    //       //   ...bolakBalik,
    //       //   [rowInd]: "",
    //       // });
    //       setDiskon({
    //         ...diskon,
    //         [rowInd]: "",
    //       });
    //       localStorage.getItem("I18N_LANGUAGE") == "en"
    //         ? setErrorMessage(
    //           `Minimal bet 4D is 1`
    //         )
    //         : setErrorMessage(
    //           `Minimal taruhan 4D adalah 1`
    //         );
    //       setShowErrorPopup(true);
    //     } else if (belliData2D < minAmount2D) {
    //       setBelliBets({
    //         ...belliBets,
    //         [`2D-${rowInd}`]: "",
    //       });
    //       setBbelli((prevBelli) => ({
    //         ...prevBelli,
    //         [rowInd]: "",
    //       }));
    //       setBolakBalik({
    //         ...bolakBalik,
    //         [rowInd]: "",
    //       });
    //       setDiskon({
    //         ...diskon,
    //         [rowInd]: "",
    //       });
    //       localStorage.getItem("I18N_LANGUAGE") == "en"
    //         ? setErrorMessage(
    //           `Minimal bet 4D is 1`
    //         )
    //         : setErrorMessage(
    //           `Minimal taruhan 4D adalah 1`
    //         );
    //       setShowErrorPopup(true);
    //     } else {
    //       let newDiskon;
    //       let newDiskon3D;
    //       let newDiskon2D;
    //       let value = belliBets[`4D-${rowInd}`] !== undefined ? belliBets[`4D-${rowInd}`] : 0;
    //       let value3D = belliBets[`3D-${rowInd}`] !== undefined ? belliBets[`3D-${rowInd}`] : 0;
    //       let value2D = belliBets[`2D-${rowInd}`] !== undefined ? belliBets[`2D-${rowInd}`] : 0;
    //       newDiskon = value > 0 ? (value * betDiscount.showMultiple * betDiscount.showDisc4d) / 100 : 0;
    //       newDiskon3D = value3D > 0 ? (value3D * betDiscount.showMultiple * betDiscount.showDisc4d) / 100 : 0;
    //       newDiskon2D = value2D > 0 ? (value2D * betDiscount.showMultiple * betDiscount.showDisc4d) / 100 : 0;

    //       let newBolakBalik;
    //       newBolakBalik = value * betDiscount.showMultiple - newDiskon;
    //       newBolakBalik += value3D * betDiscount.showMultiple - newDiskon3D;
    //       newBolakBalik += value2D * betDiscount.showMultiple - newDiskon2D;
    //       setBolakBalik({
    //         ...bolakBalik,
    //         [rowIndex]: newBolakBalik,
    //       });

    //       setDiskon({
    //         ...diskon,
    //         [rowIndex]: newDiskon ? newDiskon : "0",
    //       });
    //     }
    //   } else {
    //     // setBelliBets({
    //     //   ...belliBets,
    //     //   [rowInd]: "",
    //     // });
    //     setBbelli((prevBelli) => ({
    //       ...prevBelli,
    //       [rowInd]: "",
    //     }));
    //     setBolakBalik({
    //       ...bolakBalik,
    //       [rowInd]: "",
    //     });
    //     setDiskon({
    //       ...diskon,
    //       [rowInd]: "",
    //     });
    //   }
    // }
    let bet;

    if (device === "Desktop") {
      bet = bets["bets" + rowInd];
    } else {
      bet = mobbets["mobbets" + rowInd];
    }
    const isValid = (betNumber) => {
      return betNumber !== undefined;
    };
    const isBelliValid = (belliBet) => {
      return belliBet !== "" && belliBet !== undefined;
    };
    if (isValid(bet) && bet.length == 4 && type == "4D") {
      if (isBelliValid(belliBets[`4D-${rowInd}`])) {
        if (
          belliBets[`4D-${rowInd}`] * betDiscount.showMultiple >
          betDiscount.showMax4d
        ) {
          setBelliBets((prevBeli) => {
            const updateBelliBet = { ...prevBeli };
            updateBelliBet[`4D-${rowInd}`] = "";
            return updateBelliBet;
          });
          setErrorMessage(props.t("you_have_reached_max_bet_value"));
          setShowErrorPopup(true);
          return;
        } else if (belliBets[`4D-${rowInd}`] * betDiscount.showMultiple < betDiscount.showMin4d) {
          setBelliBets({
            ...belliBets,
            [`4D-${rowInd}`]: "",
          });
          setBbelli((prevBelli) => ({
            ...prevBelli,
            [`4D-${rowInd}`]: "",
          }));
          setBolakBalik({
            ...bolakBalik,
            [`4D-${rowInd}`]: "",
          });

          setDiskon({
            ...diskon,
            [`4D-${rowInd}`]: "",
          });
          localStorage.getItem("I18N_LANGUAGE") == "en"
            ? setErrorMessage(
              `Minimal bet ${values[rowInd].split("").filter((item) => item !== "X")
                .length + "D"
              } is 1`
            )
            : setErrorMessage(
              `Minimal taruhan ${values[rowInd].split("").filter((item) => item !== "X")
                .length + "D"
              } adalah 1`
            );
          setShowErrorPopup(true);
        }
        else if (belliBets[`4D-${rowInd}`] == 0 && belliBets[`4D-${rowInd}`] !== undefined && belliBets[`4D-${rowInd}`] !== '') {
          setBelliBets({
            ...belliBets,
            [`4D-${rowInd}`]: "",
          });
          setBbelli((prevBelli) => ({
            ...prevBelli,
            [rowInd]: "",
          }));
          setBolakBalik({
            ...bolakBalik,
            [rowInd]: "",
          });
          // localStorage.getItem("I18N_LANGUAGE") == "en"
          //   ? setErrorMessage(
          //     `Minimal bet 4D is 1`
          //   )
          //   : setErrorMessage(
          //     `Minimal taruhan 4D
          //     } adalah 1`
          //   );
          // setShowErrorPopup(true);
        }
      }
    } else if (isValid(bet) && bet.length >= 3 && type == "3D") {
      if (isBelliValid(belliBets[`4D-${rowInd}`]) && bet.length == 3) {
        setBelliBets({
          ...belliBets,
          [`4D-${rowInd}`]: "",
        });
      }
      if (isBelliValid(belliBets[`3D-${rowInd}`])) {
        if (
          belliBets[`3D-${rowInd}`] * betDiscount.showMultiple >
          betDiscount.showMax3dBelakang
        ) {
          setBelliBets({
            ...belliBets,
            [`3D-${rowInd}`]: "",
          });
          setErrorMessage(props.t("you_have_reached_max_bet_value"));
          setShowErrorPopup(true);
          return;
        }
        else if (belliBets[`3D-${rowInd}`] * betDiscount.showMultiple < betDiscount.showMin3dBelakang) {
          setBelliBets({
            ...belliBets,
            [`3D-${rowInd}`]: "",
          });
          setBbelli((prevBelli) => ({
            ...prevBelli,
            [`3D-${rowInd}`]: "",
          }));
          setBolakBalik({
            ...bolakBalik,
            [`3D-${rowInd}`]: "",
          });

          setDiskon({
            ...diskon,
            [`3D-${rowInd}`]: "",
          });
          localStorage.getItem("I18N_LANGUAGE") == "en"
            ? setErrorMessage(
              `Minimal bet ${values[rowInd].split("").filter((item) => item !== "X")
                .length + "D"
              } is 1`
            )
            : setErrorMessage(
              `Minimal taruhan ${values[rowInd].split("").filter((item) => item !== "X")
                .length + "D"
              } adalah 1`
            );
          setShowErrorPopup(true);
        }
        else if (belliBets[`3D-${rowInd}`] * betDiscount.showMultiple < betDiscount.showMin3dBelakang && belliBets[`3D-${rowInd}`] == 0 && belliBets[`3D-${rowInd}`] !== undefined) {
          setBelliBets({
            ...belliBets,
            [`3D-${rowInd}`]: "",
          });
          // localStorage.getItem("I18N_LANGUAGE") == "en"
          //   ? setErrorMessage(
          //     `Minimal bet 3D is 1`
          //   )
          //   : setErrorMessage(
          //     `Minimal taruhan 3D
          //       } adalah 1`
          //   );
          // setShowErrorPopup(true);
        }
      }
    } else if (isValid(bet) && bet.length >= 2 && type == "2D") {
      if (
        belliBets[`3D-${rowInd}`] !== "" &&
        belliBets[`3D-${rowInd}`] !== undefined &&
        bet.length == 2
      ) {
        setBelliBets({
          ...belliBets,
          [`3D-${rowInd}`]: "",
        });
      }
      if (isBelliValid(belliBets[`2D-${rowInd}`])) {
        if (
          parseInt(belliBets[`2D-${rowInd}`]) *
          parseInt(betDiscount.showMultiple) >
          parseInt(betDiscount.showMax2dBelakang)
        ) {
          setBelliBets({
            ...belliBets,
            [`2D-${rowInd}`]: "",
          });
          setErrorMessage(props.t("you_have_reached_max_bet_value"));
          setShowErrorPopup(true);
          return;
        }
        else if (belliBets[`2D-${rowInd}`] * betDiscount.showMultiple < betDiscount.showMin2dBelakang) {
          setBelliBets({
            ...belliBets,
            [`2D-${rowInd}`]: "",
          });
          setBbelli((prevBelli) => ({
            ...prevBelli,
            [`2D-${rowInd}`]: "",
          }));
          setBolakBalik({
            ...bolakBalik,
            [`2D-${rowInd}`]: "",
          });

          setDiskon({
            ...diskon,
            [`2D-${rowInd}`]: "",
          });
          localStorage.getItem("I18N_LANGUAGE") == "en"
            ? setErrorMessage(
              `Minimal bet ${values[rowInd].split("").filter((item) => item !== "X")
                .length + "D"
              } is 1`
            )
            : setErrorMessage(
              `Minimal taruhan ${values[rowInd].split("").filter((item) => item !== "X")
                .length + "D"
              } adalah 1`
            );
          setShowErrorPopup(true);
        }
        else if (belliBets[`2D-${rowInd}`] * betDiscount.showMultiple < betDiscount.showMin2dBelakang && belliBets[`2D-${rowInd}`] == 0 && belliBets[`2D-${rowInd}`] !== undefined) {
          setBelliBets({
            ...belliBets,
            [`2D-${rowInd}`]: "",
          });
          // localStorage.getItem("I18N_LANGUAGE") == "en"
          //   ? setErrorMessage(
          //     `Minimal bet 2D is 1`
          //   )
          //   : setErrorMessage(
          //     `Minimal taruhan 2D
          //       } adalah 1`
          //   );
          // setShowErrorPopup(true);
        }
      }
    }
    e.target.value = value;
    handleInputChangeBelli(e, rowIndex, "Belli", type);
  };

  useEffect(() => {
    setAngaka([]);
    setAngakaBB([]);
    let newAngaka = [];
    let newAngakaBB = [];
    let arraMatch = [];
    const allBolakBalik = bolBalikRow.filter(item => item !== undefined)

    if (allBolakBalik.length > 0) {
      newAngaka = [];
      newAngakaBB = [];

      values.forEach((val, index) => {
        let isChecked = false; // Initialize a flag to check if any item is checked
        if (val !== undefined) {
          // if (device === "Desktop") {
          //   bolBalikRow.forEach((item) => {
          //     if (
          //       item === index &&
          //       belliBets[index] !== "" &&
          //       !Number.isNaN(belliBets[index]) &&
          //       belliBets[index] !== null &&
          //       belliBets[index] !== undefined
          //     ) {
          //       newAngakaBB.push([val, parseInt(belliBets[item]), "success"]);
          //       isChecked = true; // Set the flag to true if the item is checked
          //     }
          //   });

          //   if (!isChecked && val !== undefined) {
          //     newAngaka.push([val, parseInt(belliBets[index]), "success"]);
          //   }
          // } else {
          let item4D;
          let item3D;
          let item2D;
          if (val.length == 4) {
            item4D = val;
            item3D = val.replace(/^\d/, "X");
            item2D = val.replace(/^\d{2}/, "XX");
          } else if (val.length == 3) {
            item3D = val;
            item2D = val.replace(/^\d/, "X");
          } else if (val.length == 2) {
            item2D = val;
          }

          bolBalikRow.forEach((item) => {
            if (item === index) {
              arraMatch.push(val);
              if (
                item4D &&
                belliBets[`4D-${index}`] !== "" &&
                !Number.isNaN(belliBets[`4D-${index}`]) &&
                belliBets[`4D-${index}`] !== null &&
                belliBets[`4D-${index}`] !== undefined
              ) {
                newAngakaBB.push([val, belliBets[`4D-${index}`], "success"]);
              }
              if (
                item3D &&
                belliBets[`3D-${index}`] !== "" &&
                !Number.isNaN(belliBets[`3D-${index}`]) &&
                belliBets[`3D-${index}`] !== null &&
                belliBets[`3D-${index}`] !== undefined
              ) {
                newAngakaBB.push([item3D, belliBets[`3D-${index}`], "success"]);
              }
              if (
                item2D &&
                belliBets[`2D-${index}`] !== "" &&
                !Number.isNaN(belliBets[`2D-${index}`]) &&
                belliBets[`2D-${index}`] !== null &&
                belliBets[`2D-${index}`] !== undefined
              ) {
                newAngakaBB.push([item2D, belliBets[`2D-${index}`], "success"]);
              }
              isChecked = true; // Set the flag to true if the item is checked
            }
          });

          if (!isChecked && item4D !== undefined && belliBets[`4D-${index}`] !== "" && belliBets[`4D-${index}`] !== undefined) {
            newAngaka.push([item4D, belliBets[`4D-${index}`], "success"]);
          }
          if (!isChecked && item3D !== undefined && belliBets[`3D-${index}`] !== "" && belliBets[`3D-${index}`] !== undefined) {
            newAngaka.push([item3D, belliBets[`3D-${index}`], "success"]);
          }
          if (!isChecked && item2D !== undefined && belliBets[`2D-${index}`] !== "" && belliBets[`2D-${index}`] !== undefined) {
            newAngaka.push([item2D, belliBets[`2D-${index}`], "success"]);
          }
          // }
        }
      });

      setAngakaBB(newAngakaBB);
      if (bolBalikRowALL > 0) {
        setMainButton(false);
      }

      // Check if all values are checked
      // if (device === "Desktop") {
      //   if (newAngakaBB.length === values.length) {
      //     setAngaka([]); // Set angaka to an empty array if all values are checked
      //   } else {
      //     setAngaka(newAngaka);
      //   }
      // } else {
      if (arraMatch.length === values.length) {
        setAngaka([]); // Set angaka to an empty array if all values are checked
      } else {
        setAngaka(newAngaka);
      }
      // }
    } else {
      // Handle the case when bolBalikRow is empty      
      values.forEach((item, index) => {
        if (item !== undefined) {
          // if (device === "Desktop") {
          //   if (
          //     item !== undefined &&
          //     belliBets[index] !== "" &&
          //     !Number.isNaN(belliBets[index]) &&
          //     belliBets[index] !== null &&
          //     belliBets[index] !== undefined
          //   ) {
          //     newAngaka.push([
          //       item,
          //       parseInt(belliBets[index]) * betDiscount.showMultiple,
          //       "success",
          //     ]);
          //   }
          // } else {
          let item4D;
          let item3D;
          let item2D;
          if (item.length == 4) {
            item4D = item;
            item3D = item.replace(/^\d/, "X");
            item2D = item.replace(/^\d{2}/, "XX");
          } else if (item.length == 3) {
            item3D = item;
            item2D = item.replace(/^\d/, "X");
          } else if (item.length == 2) {
            item2D = item;
          }

          if (
            item4D &&
            belliBets[`4D-${index}`] !== "" &&
            !Number.isNaN(belliBets[`4D-${index}`]) &&
            belliBets[`4D-${index}`] !== null &&
            belliBets[`4D-${index}`] !== undefined
          ) {
            newAngaka.push([
              item4D,
              belliBets[`4D-${index}`] * betDiscount.showMultiple,
              "success",
            ]);
          }
          if (
            item3D &&
            belliBets[`3D-${index}`] !== "" &&
            !Number.isNaN(belliBets[`3D-${index}`]) &&
            belliBets[`3D-${index}`] !== null &&
            belliBets[`3D-${index}`] !== undefined
          ) {
            newAngaka.push([
              item3D,
              belliBets[`3D-${index}`] * betDiscount.showMultiple,
              "success",
            ]);
          }
          if (
            item2D &&
            belliBets[`2D-${index}`] !== "" &&
            !Number.isNaN(belliBets[`2D-${index}`]) &&
            belliBets[`2D-${index}`] !== null &&
            belliBets[`2D-${index}`] !== undefined
          ) {
            newAngaka.push([
              item2D,
              belliBets[`2D-${index}`] * betDiscount.showMultiple,
              "success",
            ]);
          }
          // }
        }
      });
      setAngaka(newAngaka);
    }
  }, [values, bolBalikRow, belliBets]);

  function setAngakaArray() {
    if (angaka.length !== undefined) {
      if (angaka.length > 0) {
        const filteredAngaka = angaka.filter(
          (item) =>
            item !== undefined &&
            item[1] !== undefined &&
            item[1] !== "" &&
            !Number.isNaN(item[1]) &&
            item[1] !== null
        );
        setReqData({
          ...reqData,
          gameId: gameId,
          dataangka: filteredAngaka,
        });
      } else {
        setReqData({
          ...reqData,
          gameId: gameId,
          dataangka: [],
        });
      }
    }
  }

  useEffect(() => {
    setAngakaArray();
  }, [angaka]);

  useEffect(() => {
    allDataReset();
  }, [gameId]);

  useEffect(() => {
    let newAgkaArrays = [];
    bolakBalikRespArray.map((val) => {
      if (val.showNumber) {
        val.showNumber.map((value) => {
          const newAgkaArray = [value, val.taruhan, "success"];
          newAgkaArrays.push(newAgkaArray);
        });
      }
    });
    setCheckedBoxes(Array(bolakBalikRespArray.length).fill(true));
    setBolakBalikRespAngka(newAgkaArrays);
    setReqBBData({
      ...reqBBData,
      gameId: gameId,
      dataangka: newAgkaArrays,
    });
  }, [bolakBalikRespArray]);

  useEffect(() => {
    setReqBBData({
      ...reqBBData,
      gameId: gameId,
      dataangka: bolakBalikRespAngka,
    });
    if (bolakBalikRespArray.length > 0) {
      const newPayAmount = totalBetAmount.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      let addDiscount = diskon.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      setDiscountAmount(addDiscount);
      setPayAmount(newPayAmount);
    }
  }, [bolakBalikRespAngka]);

  const handleCheckboxToggle = (index) => {
    const newCheckedBoxes = [...checkedBoxes];
    newCheckedBoxes[index] = !newCheckedBoxes[index];
    setCheckedBoxes(newCheckedBoxes);
  };

  let i = 0;
  const updateReqData = () => {
    let newAgkaArrays = [];
    let newAngakaData = [];
    let updateNeAngaka = [];

    if (bolakBalikRespArray.length > 0) {
      setBolakBalikRespAngka([]);
      setNewAngakaD([]);
    }
    let addPayAmount = 0;
    let addDiscountAmount = 0;

    bolakBalikRespArray.forEach((val, ind) => {
      if (checkedBoxes[ind] !== false) {
        if (val.showNumber) {
          let newAgkaArr;
          val.showNumber.forEach((value) => {
            let newAgkaArray;
            if (val.type === "2D Belakang") {
              newAgkaArray = ["XX" + value, val.taruhan, "success"];
              newAgkaArr = "XX" + val.angka;
            } else if (val.type === "2D Depan") {
              newAgkaArray = [value + "XX", val.taruhan, "success"];
              newAgkaArr = val.angka + "XX";
            } else if (val.type === "2D Tengah") {
              newAgkaArray = ["X" + value + "X", val.taruhan, "success"];
              newAgkaArr = "X" + val.angka + "X";
            } else if (val.type === "3D Belakang") {
              newAgkaArray = ["X" + value, val.taruhan, "success"];
              newAgkaArr = "X" + val.angka;
            } else if (val.type === "3D Depan") {
              newAgkaArray = [value + "X", val.taruhan, "success"];
              newAgkaArr = val.angka + "X";
            } else if (val.type === "4D") {
              newAgkaArray = [value, val.taruhan, "success"];
              newAgkaArr = val.angka;
            }
            newAgkaArrays.push(newAgkaArray);
          });
          updateNeAngaka.push(newAgkaArr);
        }
      }
    });

    if (bolakBalikRespArray.length > 0 && reqData.dataangka.length > 0) {
      // if (device === "Desktop") {
      //   reqData.dataangka.map((value, ind) => {
      //     if (value[0] !== undefined && !Number.isNaN(value[1])) {
      //       newAngakaData.push([value[0], value[1] * betDiscount.showMultiple, 'success']);
      //     }
      //   })
      // }
      // else {

      reqData.dataangka.map((value) => {
        if (value[0] !== undefined && !Number.isNaN(value[1])) {
          if (value[0].length == 2) {
            newAngakaData.push([
              "XX" + value[0],
              value[1] * betDiscount.showMultiple,
              "success",
            ]);
          } else if (value[0].length == 3) {
            newAngakaData.push([
              "X" + value[0],
              value[1] * betDiscount.showMultiple,
              "success",
            ]);
          } else {
            newAngakaData.push([
              value[0],
              value[1] * betDiscount.showMultiple,
              "success",
            ]);
          }
        }
      });
      // }
    }

    setPayAmount(addPayAmount);
    setDiscountAmount(addDiscountAmount);
    setBolakBalikRespAngka(newAgkaArrays);
    setNewAngakaD(newAngakaData);
  };

  useEffect(() => {
    updateReqData();
  }, [checkedBoxes, reqData]);

  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };

  const submitProcessOk = async () => {
    setShowConfirmationPopup(false);
    if (reqData.dataangka.length > 0 || reqBBData.dataangka.length > 0) {
      const processApiResponse = async (requestData) => {
        try {
          const response = await makeAjax(
            url.TOGEL_API.process4D3D2D,
            requestData
          );
          if (response.status !== respStatus["SUCCESS"]) {
            if (response.code === "sub_game_status_close") {
              setShowGameClose(true);
              showMessage(false);
              hideCommonToaster();
              dispatch(
                setCommonConfig({ key: "subGameOnOffStatus", value: 0 })
              );
              return;
            }
            if (response.code === "market_close_err") {
              setShowMarketClose(true);
              showMessage(false);
              hideCommonToaster();
              dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
              return;
            }
            if (response.code !== "validation_error") {
              response.code
                ? setErrorMessage(props.t(response.code))
                : showMessage(
                  props.t("guess_bet_wrong_place"),
                  "error",
                  "error"
                );
              setShowErrorPopup(true);
              return false;
            }
            showMessage("server error No data find", "error", "error");
            return false;
          }
          setRespData((prevArray) => [...prevArray, response.data]);
          return true;
        } catch (error) {
          showMessage(
            "An error occurred while processing the request",
            "error",
            "error"
          );
          return false;
        }
      };

      let isSuccess = true;

      if (
        bolakBalikRespArray.length > 0 &&
        bolBalikRow.filter((item) => item !== undefined).length > 0
      ) {
        if (reqBBData.dataangka.length > 0) {
          isSuccess = await processApiResponse(reqBBData);
        }
        if (isSuccess && newReqData.dataangka.length > 0) {
          isSuccess = await processApiResponse(newReqData);
        }
      } else {
        isSuccess = await processApiResponse(reqData);
      }

      if (isSuccess) {
        setSuccessPopup(true);
        allDataReset();
      }
      dispatch(getUserBalance());
    } else {
      setErrorMessage(props.t("guess_bet_wrong"));
      setShowErrorPopup(true);
    }
  };

  const submitProcess = (event) => {
    const valLeng = values.filter((item) => item !== undefined);

    const valBelli = Object.entries(belliBets).filter(
      ([key, value]) => value !== undefined && value !== ""
    );
    const total = Object.values(bolakBalik).reduce(
      (total, item) => total + item,
      0
    );
    if (
      parseFloat(payAmount) > parseFloat(user_balance.coin) &&
      bolakBalikRespArray.length > 0
    ) {
      setErrorMessage(props.t("insufficiant_balance_err"));
      setShowErrorPopup(true);
    } else if (
      parseFloat(total) > parseFloat(user_balance.coin) &&
      bolakBalikRespArray.length === 0
    ) {
      setErrorMessage(props.t("insufficiant_balance_err"));
      setShowErrorPopup(true);
    } else {
      if (values.length > 0 && Object.keys(belliBets).length > 0) {
        if (valLeng.length === valBelli.length) {
          setSuccessMessage("");
          setShowConfirmationPopup(true);
        } else if (valLeng.length === Object.keys(bolakBalik).length) {
          setSuccessMessage("");
          setShowConfirmationPopup(true);
        } else {
          setSuccessMessage("");
          setShowConfirmationPopup(true);
        }
      } else {
        setErrorMessage(props.t("guess_bet_wrong"));
        setShowErrorPopup(true);
      }
    }
  };

  const handleDeafultInputBlur = (e, betType) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin4d).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultvalue(value);
    }
  }

  const handleDeafultInputBlur3D = (e, betType) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';

    if (String(betDiscount.showMin3dBelakang).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultvalue3D(value)
    }
  }

  const handleDeafultInputBlur2D = (e, betType) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin2dBelakang).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }

    if (regex.test(value)) {
      setDefaultvalue2D(value)
    }
  }

  const handleDeafultInputChange = (e, betType) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin4d).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }

    if (regex.test(value)) {
      setDefaultvalue(value);
    }
  };

  const handleDeafultInputChange3D = (e, betType) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin3dBelakang).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    if (regex.test(value)) {
      setDefaultvalue3D(value);
    }
  };

  const handleDeafultInputChange2D = (e, betType) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin2dBelakang).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }

    if (regex.test(value)) {
      setDefaultvalue2D(value);
    }
  };

  const handleRowsToShowChange = (e) => {
    setRowsToShow(parseInt(e.target.value, 10));
  };

  useEffect(() => {
    setBeliDisabled((prevBeliDisabled) => {
      if (prevBeliDisabled !== false) {
        return [...prevBeliDisabled, ...Array(rowsToShow).fill(true)];
      } else {
        return prevBeliDisabled.slice(0, rowsToShow);
      }
    });
    setBeliDisabled3D((prevBeliDisabled) => {
      if (prevBeliDisabled !== false) {
        return [...prevBeliDisabled, ...Array(rowsToShow).fill(true)];
      } else {
        return prevBeliDisabled.slice(0, rowsToShow);
      }
    });
    setBeliDisabled2D((prevBeliDisabled) => {
      if (prevBeliDisabled !== false) {
        return [...prevBeliDisabled, ...Array(rowsToShow).fill(true)];
      } else {
        return prevBeliDisabled.slice(0, rowsToShow);
      }
    });
  }, [rowsToShow]);

  const allDataReset = () => {
    setBets({});
    setBelliBets({});
    setMobBets({});
    setValues([]);
    setBbelli({});
    setDiskon({});
    setBolakBalik({});
    setReqData(initialAngaka);
    setNewReqData(initialAngaka);
    setReqBBData(initialAngaka);
    setNewAngakaD([]);
    setBolakBalikRespArray([]);
    setBolakBalikRespAngka([]);
    setBolBalikRow([]);
    setBolBalikRowAll(0);
    setDefaultvalue("");
    setDefaultvalue3D("");
    setDefaultvalue2D("");
    setBeliDisabled(Array(rowsToShow).fill(true));
    setBeliDisabled3D(Array(rowsToShow).fill(true));
    setBeliDisabled2D(Array(rowsToShow).fill(true));
    document.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.checked = false;
    });
    setProbabilityTable(false);
    setMainButton(true);
    setTotalAmount(0);
    setBBPayAmount(0);
    setTotalBetAmount([]);
  };

  //new/////
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const updatedBeliDisabled = [...beliDisabled];
    const newBets = { ...bets };
    const newMobBets = { ...mobbets };
    const newValues = [...values];
    const newBelli = { ...belli };
    const newBelliBets = { ...belliBets };
    const newDiskon = { ...diskon };
    const newBolak = { ...bolakBalik };

    const updatedBolBalikRow = [];

    document
      .querySelectorAll('input[type="checkbox"].chk_bb')
      .forEach((checkbox, index) => {
        checkbox.checked = isChecked;
        if (isChecked) {
          setBolBalikRowAll(1);
          if (newValues[index] && newBelliBets[index] !== undefined) {
            updatedBeliDisabled[index] = false;
            updatedBolBalikRow.push(index);
            // Ensure the state updates for selected items
            newBets[`bets${index}0`] = newBets[`bets${index}0`] || ""; // Set any initial required state
            newBets[`bets${index}1`] = newBets[`bets${index}1`] || "";
            newBets[`bets${index}2`] = newBets[`bets${index}2`] || "";
            newBets[`bets${index}3`] = newBets[`bets${index}3`] || "";
            newMobBets[index] = newMobBets[index] || "";
            newValues[index] = newValues[index] || "";
            newBelli[index] = newBelli[index] || "";
            newBelliBets[index] = newBelliBets[index] || "";
            newDiskon[index] = newDiskon[index] || "";
            newBolak[index] = newBolak[index] || "";
          } else {
            updatedBolBalikRow.push(index);
          }
        } else {
          setBolBalikRowAll(0);
        }
      });

    if (!isChecked) {
      setBolBalikRow([]); // Clear bolBalikRow if not checked
    } else {
      setBolBalikRow(updatedBolBalikRow); // Set bolBalikRow with updated indexes
    }

    setBets(newBets);
    setMobBets(newMobBets);
    setValues(newValues);
    setBbelli(newBelli);
    setBelliBets(newBelliBets);
    setDiskon(newDiskon);
    setBolakBalik(newBolak);
    setBeliDisabled(updatedBeliDisabled);
    setMainButton(!isChecked); // Enable or disable the main button based on the state
  };

  // Ensure checkInputHandler function also updates bolBalikRow accordingly
  const checkInputHandler = (e, rowIndex, columnName) => {
    setRowInd(rowIndex);
    let newBolakBalikRow = [...bolBalikRow];
    let checkVal = document.getElementById("checkValue" + rowIndex);
    if (checkVal.checked) {
      setMainButton(false);
      values.forEach((_, ind) => {
        if (newBolakBalikRow[ind] === undefined) {
          newBolakBalikRow[ind] = undefined;
        }
      });
      newBolakBalikRow[rowIndex] = rowIndex;
      setBolBalikRow(newBolakBalikRow);
    } else {
      setMainButton(true);
      if (bolBalikRowALL > 0) {
        newBolakBalikRow[rowIndex] = undefined;
        setBolBalikRow(newBolakBalikRow);
      } else {
        newBolakBalikRow[rowIndex] = undefined;
        setBolBalikRow(newBolakBalikRow);
      }
    }
    let rowBet;
    if (device === "Desktop") {
      rowBet = bets["bets" + rowInd];
    } else {
      rowBet = mobbets["mobbets" + rowInd];
    }
    
    // if (device === "Mobile") {   
    if (newBolakBalikRow.filter((item) => item !== undefined).length > 0) {
      const updateAmount = mobileTotalBetCalculate("4D3D2D", rowBet, belliBets, rowIndex, betDiscount, true, newBolakBalikRow, bolBalikRowALL, values, "discount", device)

      if (device === "Desktop") {
        setBBPayAmount(updateAmount[0]);
        setTotalBetAmount(updateAmount[2]);
        setDiskon(updateAmount[1]);
      } else {
        setTotalBetAmount(updateAmount[0]);
        setDiskon(updateAmount[1]);
      }
    } else {
      setBBPayAmount(0);
    }
    // }
  };

  useEffect(() => {
    setNewReqData({
      ...newReqData,
      gameId: gameId,
      dataangka: newAngakaD,
    });
  }, [newAngakaD]);

  const submitProcessBB = (e) => {
    setProbabilityTable(false);
    setBolakBalikRespArray([]);
    setTotalAmount(0);
    let index = 1;
    // return
    if (angakaBB.length > 0) {
      if (Object.keys(belliBets).length > 0) {
        values.map((val, ind) => {
          if (val !== undefined) {
            let item4D;
            let item3D;
            let item2D;
            let bolakArray = [];
            let belliArray = [];
            if (val.length == 4) {
              if (device === "Desktop") {
                item4D = val;
                item3D = val.replace(/^\d/, "X");
                item2D = val.replace(/^\d{2}/, "XX");
              } else {
                item4D = val;
                item3D = val.replace(/^\d/, "");
                item2D = val.replace(/^\d{2}/, "");
              }
              bolakArray = [item4D, item3D, item2D];
              belliArray = [
                belliBets[`4D-${ind}`] !== undefined
                  ? belliBets[`4D-${ind}`]
                  : "",
                belliBets[`3D-${ind}`] !== undefined
                  ? belliBets[`3D-${ind}`]
                  : "",
                belliBets[`2D-${ind}`] !== undefined
                  ? belliBets[`2D-${ind}`]
                  : "",
              ];
            } else if (val.length == 3) {
              if (device === "Desktop") {
                item3D = "X" + val;
                item2D = val.replace(/^\d/, "XX");
              } else {
                item3D = val;
                item2D = val.replace(/^\d/, "");
              }
              bolakArray = ["", item3D, item2D];
              belliArray = ["", belliBets[`3D-${ind}`], belliBets[`2D-${ind}`]];
            } else if (val.length == 2) {
              if (device === "Desktop") {
                item2D = "XX" + val;
              } else {
                item2D = val;
              }
              bolakArray = ["", "", item2D];
              belliArray = ["", "", belliBets[`2D-${ind}`]];
            }

            bolakArray.map((data, chInd) => {
              if (
                data !== "" &&
                belliArray[chInd] !== "" &&
                belliArray[chInd] !== undefined &&
                !Number.isNaN(belliArray[chInd]) &&
                belliArray[chInd] !== null
              ) {
                if (
                  ind === bolBalikRow[ind] &&
                  bolBalikRow[ind] !== undefined
                ) {
                  const action = "generate";
                  const reqBBData = {
                    action: action,
                    gameId: gameId,
                    gameType: "bolak-balik",
                    betTogelAuth: "betTogelAuth",
                    allowPartner: null,
                    checklistid: ++index,
                    dataangka: [data, belliArray[chInd], "success", val],
                    mobBets: (device === "Desktop") ? 0 : 1,
                    multiple: betDiscount.showMultiple,
                  };
                  bolakBalikSubmit(reqBBData);
                } else {
                  const action = "generate4d3d2d";
                  const reqBBData = {
                    action: action,
                    gameId: gameId,
                    gameType: "bolak-balik",
                    betTogelAuth: "betTogelAuth",
                    allowPartner: null,
                    checklistid:
                      index + chInd == index
                        ? index + chInd + ind
                        : index + chInd,
                    dataangka: [data, belliArray[chInd], "success"],
                    mobBets: (device === "Desktop") ? 0 : 1,
                    multiple: betDiscount.showMultiple,
                  };
                  bolakBalikSubmit(reqBBData);
                }
              }
            });
          }
        });
        setMainButton(true);
      } else {
        setErrorMessage(props.t("guess_bet_wrong"));
        setShowErrorPopup(true);
      }
    } else {
      if (values.length > 0) {
        if (angaka.length > 0) {
          let newDataAngaka = reqData.dataangka;
          newDataAngaka.map((item, ind) => {
            item[1] = item[1] * betDiscount.showMultiple;
          });
          setReqData({
            ...reqData,
            dataangka: newDataAngaka,
          });
          setSuccessMessage("");
          setShowConfirmationPopup(true);
        } else {
          setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
        }
      } else {
        document
          .querySelectorAll('input[type="checkbox"]')
          .forEach((checkbox) => {
            checkbox.checked = false;
          });
        setBolBalikRow([]);
        setMainButton(true);
        setBolBalikRowAll(0);
      }
    }
  };

  const bolakBalikSubmit = (bbData) => {
    makeAjax(url.TOGEL_API.processBolakBalik, bbData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          response.code
            ? showMessage(props.t(response.code), "error", "error")
            : showMessage(props.t("guess_bet_wrong_place"), "error", "error");
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setBolakBalikRespArray((prevArray) => [...prevArray, response.data]);
      setTotalAmount((prevTotal) => {
        const newTotal =
          prevTotal +
          response.data.taruhan *
          (typeof response.data.showNumber != "undefined"
            ? response.data.showNumber.length
            : 1);
        return newTotal;
      });
      setProbabilityTable(true);
      setMainButton(true);
    });
  };

  const handlePopupClose = () => {
    setRespData([]);
    setSuccessPopup(false);
    setProbabilityTable(false);
    allDataReset();
    setTotalAmount(0);
    setBBPayAmount(0);
    setTotalBetAmount([]);
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCancelledPopup(true);
  };
  useEffect(() => {
    if (device === "Mobile" && probabilityTable) {
      totaldiv.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [bolakBalikRespArray, device]);

  const [isPopupShownonce, setIsPopupShownOnce] = useState(false);
  return (
    <>
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          <div className="container">
            {/* {device === "Mobile" && ( */}
            <CommonBetHeader
              rowsToShow={rowsToShow}
              handleRowsToShowChange={handleRowsToShowChange}
              bbPayAmount={bbPayAmount}
              totalBetAmount={totalBetAmount}
            />
            {/* )} */}
            {/* <table className="bet-diskon-table"> */}
            <table className="bet-diskon-table" ref={guessRef}>
              <thead 
              // ref={resetRef}
              >
                {device === "Desktop" ? (
                  <>
                    <tr className="Heading betheading">
                      <th>{props.t("no.")}</th>
                      {/* <th className="check_column">
                      {props.t("BB")}
                      <input
                        type="checkbox"
                        onClick={(e) => handleSelectAll(e)}
                      />
                    </th> */}
                      <th className={`guess-bet custom-tooltip-wrapper ${currentStep === 2 ? "highlighted" : ""}`}>
                        {props.t("guess")}
                        {currentStep === 2 && <CoachMarkPopup />
                        }

                      </th>


                      {/* <th>
                      <label htmlFor="belliInput">{props.t("buy")}</label>
                      <input
                        id="belliInput"
                        type="text"
                        autoComplete="off"
                        placeholder="1 = 1,000"
                        className="small_input"
                        value={defaultValue}
                        onChange={handleDeafultInputChange}
                      />
                    </th> */}
                      {/* <th>{props.t("discount")}</th>
                    <th>{props.t("pay")}</th> */}
                      {/* <th style={{ whiteSpace: "nowrap" }}>
                      {props.t("line")}
                      <TableCount
                        rowsToShow={rowsToShow}
                        handleRowsToShowChange={handleRowsToShowChange}
                      />
                    </th> */}

                      <th className={`d-flex align-right ${currentStep === 3 ? "highlighted" : ""}`}>
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Auto Bet"
                          value={defaultValue}
                          onChange={(e) => handleDeafultInputChange(e, "4D")}
                          onBlur={(e) => handleDeafultInputBlur(e, "4D")}
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                        />
                      </th>
                      <th className={`auto-bet custom-tooltip-wrapper ${currentStep === 3 ? "highlighted" : ""}`}>
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Auto Bet"
                          value={defaultValue3D}
                          onChange={(e) => handleDeafultInputChange3D(e, "3D")}
                          onBlur={(e) => handleDeafultInputBlur3D(e, "3D")}
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                        />
                        {currentStep === 3 && <CoachMarkPopup />}



                      </th>


                      <th className={` ${currentStep === 3 ? "highlighted" : ""}`}>
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Auto Bet"
                          value={defaultValue2D}
                          onChange={(e) => handleDeafultInputChange2D(e, "2D")}
                          onBlur={(e) => handleDeafultInputBlur2D(e, "2D")}
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                        />
                      </th>

                      <th className={`discount-tab custom-tooltip-wrapper ${currentStep === 5 ? "highlighted" : ""}`}>
                        {props.t("discount")}

                        {currentStep === 5 && <CoachMarkPopup />}

                      </th>


                      <th className={` ${currentStep === 5 ? "highlighted" : ""}`}>{props.t("pay")}</th>

                      <th className={`check_column custom-tooltip-wrapper ${currentStep === 4 ? "highlighted" : ""}`}>
                        {props.t("BB")}
                        <div>

                          <input
                            type="checkbox"
                            onClick={(e) => handleSelectAll(e)}
                          />
                        </div>
                        {currentStep === 4 && <CoachMarkPopup />}
                        {/* <div className="custom-tooltip">
                          <div className="quick-tip">
                            <TbBulb />
                            <span>Quick tip 5/11</span>
                          </div>
                          <div className="text">BB (Bolak Balik)</div>
                          <p className="market-bet">
                            Toggel BB to create all number combinations.
                          </p>
                          <div className="custom-action">
                            <div className="custom-bet">SKIP ALL</div>
                            <div className="custom-bet">
                              NEXT
                              <div className="right-arr">
                                <MdKeyboardArrowRight />
                              </div>
                            </div>
                          </div>

                          <span className="custom-tooltip-arrow"></span>
                        </div> */}
                        {/* <CoachMarkPopup/> */}
                      </th>

                    </tr>
                    {currentStep === 2 && <div className="custom-overlay"></div>}
                    {currentStep === 3 && <div className="custom-overlay"></div>}
                    {currentStep === 4 && <div className="custom-overlay"></div>}
                    {currentStep === 5 && <div className="custom-overlay"></div>}
                  </>
                ) : (
                  <>
                    <tr className="Heading betheading">
                      <th>{props.t("no.")}</th>
                      <th>{props.t("number")}</th>
                      <th colSpan={4}>{props.t("bet")}</th>
                    </tr>
                    {/* <tr ref={guessRef}> */}
                    <tr >
                      <th>&nbsp;</th>
                      <th>&nbsp;</th>
                      <th className={`auto-bet custom-tooltip-wrapper d-flex align-right ${currentStep === 3 ? "highlighted" : ""}`}>
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Auto Bet"
                          value={defaultValue}
                          onChange={(e) => handleDeafultInputChange(e, "4D")}
                          onBlur={(e) => handleDeafultInputBlur(e, "4D")}
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                        />
                      </th>
                      <th className={`auto-bet custom-tooltip-wrapper ${currentStep === 3 ? "highlighted" : ""}`}>
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Auto Bet"
                          value={defaultValue3D}
                          onChange={(e) => handleDeafultInputChange3D(e, "3D")}
                          onBlur={(e) => handleDeafultInputBlur3D(e, "3D")}
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                        />
                        {currentStep === 3 && <CoachMarkPopup />}
                      </th>
                      <th className={`auto-bet custom-tooltip-wrapper ${currentStep === 3 ? "highlighted" : ""}`}>
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder="Auto Bet"
                          value={defaultValue2D}
                          onChange={(e) => handleDeafultInputChange2D(e, "2D")}
                          onBlur={(e) => handleDeafultInputBlur2D(e, "2D")}
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                        />
                      </th>
                      <th className={`check_column custom-tooltip-wrapper ${currentStep === 4 ? "highlighted" : ""}`} ref={bbRef}>
                        {props.t("BB")}
                        <div>

                          <input
                            type="checkbox"
                            onClick={(e) => handleSelectAll(e)}
                          />
                          {currentStep === 4 && <CoachMarkPopup />}
                        </div>

                      </th>
                      {currentStep === 3 && <div className="custom-overlay"></div>}
                      {currentStep === 4 && <div className="custom-overlay"></div>}
                    </tr>
                  </>
                )}
              </thead>
              <tbody>
                {[...Array(rowsToShow)].map((_, index) => (
                  <tr
                    key={index}
                    className={
                      index % 2 === 0
                        ? "even-row td-padding"
                        : "odd-row td-padding"
                    }
                    // ref={resetRef}
                  >
                    <td>{index + 1}</td>
                    {device === "Desktop" ? (
                      <>
                        {/* <td className="inputs"> */}
                        <td className={`guess-bet custom-tooltip-wrapper ${currentStep === 2 ? "highlighted" : ""}`}>

                          {/* <td className="number-inputs"> */}
                          {/* {[...Array(inputToShow)].map((_, keyInp) => (
                            <input
                              key={"betInput" + index + "" + keyInp}
                              autoComplete="off"
                              type="text"
                              maxlength="1"
                              className={`betInput${index}${keyInp}`}
                              ref={(el) =>
                                (colRef.current[`${index}${keyInp}`] = el)
                              }
                              name={`bets${index}${keyInp}`}
                              value={
                                bets["bets" + index + "" + keyInp]
                                  ? bets["bets" + index + "" + keyInp]
                                  : ""
                              }
                              onChange={(e) =>
                                handleInputChange(e, index, keyInp, "Tebak")
                              }
                              onBlur={(e) => handleInputBlur(e, index, keyInp)}
                              onFocus={(e) => hendleInputFocus(e, index, keyInp)}
                            />
                          ))} */}

                          <input

                            key={"betInput" + index}
                            autoComplete="off"
                            type="text"
                            maxlength="4"
                            name={`bets${index}`}
                            value={
                              bets[`bets${index}`] ? bets[`bets${index}`] : ""
                            }
                            onChange={(e) =>
                              handleInputChange(e, index, null, "Tebak")
                            }
                            onBlur={(e) => handleInputBlur(e, index, "Tebak")}
                            onFocus={(e) => hendleInputFocus(e, index, "Tebak")}
                            inputMode="numeric"
                          />
                        </td>
                        {/* {currentStep === 2 && !isPopupShown && (<CoachMarkPopup />)} */}
                      </>
                    ) : (
                      <>

                        <td className={`inputs guess-bet custom-tooltip-wrapper ${currentStep === 2 ? "highlighted" : ""}`}>
                          <input
                            type="text"
                            maxlength="4"
                            autoComplete="off"
                            name={`mobbets${index}`}
                            value={
                              mobbets[`mobbets${index}`]
                                ? mobbets[`mobbets${index}`]
                                : ""
                            }
                            onBlur={(e) => handleInputBlur(e, index)}
                            onChange={(e) => handleInputChange(e, index, "Tebak")}
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                          {currentStep === 2 && device === "Desktop" && !isPopupShown && (<CoachMarkPopup />)}
                          {currentStep === 2 && device === "Mobile" && index === 0 ? <CoachMarkPopup /> : ""}

                        </td>
                        {currentStep === 2 && index === 0 && <div className="custom-overlay"></div>}
                      </>
                    )}


                    {/* {device === "Desktop" ? ( */}
                    <>
                      {/* <td className="inputs">
                          <input
                            type="text"
                            autoComplete="off"
                            placeholder="1 = 1,000 IDR"
                            name={`${index}`}
                            value={belliBets[index] ? belliBets[index] : ""}
                            ref={(el) => (colRef.current[`${index}-belli`] = el)}
                            onChange={(e) =>
                              handleInputChangeBelli(e, index, "Belli")
                            }
                            onFocus={(e) => handleFocusInput(e, index)}
                            disabled={beliDisabled[index]}
                            onBlur={(e) => handleBelliChangeBlur(index)}
                            inputMode="numeric"
                            pattern="[0-9]*"
                          />
                        </td> */}
                      {/* <td className="inputs">
                          <input
                            name={index}
                            readOnly
                            tabindex="-1"
                            type="text"
                            value={diskon[index] ? formatPrice(diskon[index]) : ""}
                          />
                        </td>
                        <td className="inputs">
                          <input
                            name={index}
                            readOnly
                            tabindex="-1"
                            type="text"
                            value={
                              bolakBalik[index]
                                ? formatPrice(bolakBalik[index])
                                : ""
                            }
                          />
                        </td> */}
                      {/* <td className="inputs">
                          <button
                            onClick={(e) => rowDataReset(index)}
                            tabindex="-1"
                            className="reset-button"
                          >
                            Reset
                          </button>
                        </td> */}
                      {/* </>
                    ) : (
                      <> */}
                      <td className={`inputs auto-bet custom-tooltip-wrapper ${currentStep === 3 ? "highlighted" : ""}`}>
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder={beliDisabled[index] == true ? "4D" : ""}
                          name={`4D-${index}`}
                          value={
                            belliBets[`4D-${index}`] &&
                              beliDisabled[index] == false
                              ? belliBets[`4D-${index}`]
                              : ""
                          }
                          ref={(el) => (colRef.current[`${index}-belli`] = el)}
                          onChange={(e) =>
                            handleInputChangeBelli(e, index, "Belli", "4D")
                          }
                          onFocus={(e) => handleFocusInput(e, index, "4D")}
                          disabled={beliDisabled[index]}
                          onBlur={(e) => handleBelliChangeBlur(e, index, "4D")}
                          className="input-bg"
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                          style={{ minWidth: 50 }}
                        />
                      </td>
                      <td className={`inputs auto-bet custom-tooltip-wrapper ${currentStep === 3 ? "highlighted" : ""}`}>
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder={
                            beliDisabled3D[index] == true ? "3D Blkg" : ""
                          }
                          name={`3D-${index}`}
                          value={
                            belliBets[`3D-${index}`] &&
                              beliDisabled3D[index] == false
                              ? belliBets[`3D-${index}`]
                              : ""
                          }
                          ref={(el) => (colRef.current[`3D-${index}`] = el)}
                          onChange={(e) =>
                            handleInputChangeBelli(e, index, "Belli", "3D")
                          }
                          onFocus={(e) => handleFocusInput(e, index, "3D")}
                          disabled={beliDisabled3D[index]}
                          onBlur={(e) => handleBelliChangeBlur(e, index, "3D")}
                          className="input-bg"
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                          style={{ minWidth: 50 }}
                        />
                      </td>
                      <td className={`inputs auto-bet custom-tooltip-wrapper ${currentStep === 3 ? "highlighted" : ""}`}>
                        <input
                          type="text"
                          autoComplete="off"
                          placeholder={
                            beliDisabled2D[index] == true ? "2D Blkg" : ""
                          }
                          name={`2D-${index}`}
                          value={
                            belliBets[`2D-${index}`] &&
                              beliDisabled2D[index] == false
                              ? belliBets[`2D-${index}`]
                              : ""
                          }
                          ref={(el) =>
                            (colRef.current[`2D-${index}-Blkg`] = el)
                          }
                          onChange={(e) =>
                            handleInputChangeBelli(e, index, "Belli", "2D")
                          }
                          onFocus={(e) => handleFocusInput(e, index, "2D")}
                          disabled={beliDisabled2D[index]}
                          onBlur={(e) => handleBelliChangeBlur(e, index, "2D")}
                          className="input-bg"
                          inputMode="decimal"
                          pattern="[0-9]*[.,]?[0-9]**"
                          style={{ minWidth: 50 }}
                        />
                      </td>
                      {device === "Desktop" && (
                        <>
                          <td className={`inputs discount-tab custom-tooltip-wrapper ${currentStep === 5 ? "highlighted" : ""}`}>
                            <input
                              name={index}
                              readOnly
                              tabindex="-1"
                              type="text"
                              value={
                                diskon[index] ? formatPrice(diskon[index]) : ""
                              }
                            />
                          </td>
                          <td className={`inputs discount-tab custom-tooltip-wrapper ${currentStep === 5 ? "highlighted" : ""}`}>
                            <input
                              name={index}
                              readOnly
                              tabindex="-1"
                              type="text"
                              value={
                                totalBetAmount[index]
                                  ? formatPrice(totalBetAmount[index])
                                  : ""
                              }
                            />
                          </td>
                        </>
                      )}
                      <td className={`guess-bet custom-tooltip-wrapper ${currentStep === 4 ? "highlighted" : ""}`}>
                        <input
                          tabindex="-1"
                          type="checkbox"
                          id={`checkValue${index}`}
                          onClick={(e) => checkInputHandler(e, index, "")}
                          className="chk_bb"
                        />
                      </td>
                    </>
                    {/* )} */}


                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {probabilityTable && (
            <div className="fourDThreeDTwoD_probability_container">
              <div className="probability_container">
                <table>
                  <thead>
                    <tr className="Heading">
                      <th>{props.t("no.")}</th>
                      <th></th>
                      <th>{props.t("guess")}</th>
                      {/* <th>{props.t("Tipe")}</th> */}
                      <th>{props.t("buy")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bolakBalikRespArray.length == 0 ? (
                      <tr className="table_data_empty_row">
                        <td colSpan="11">{"data_not_found"}</td>
                      </tr>
                    ) : (
                      bolakBalikRespArray.map((value, index) => (
                        <tr
                          key={index}
                          className={index % 2 === 0 ? "even-row" : "odd-row"}
                        >
                          <td>{index + 1}</td>
                          <td align="center">
                            <input
                              type="checkbox"
                              className="chk_bb"
                              checked={checkedBoxes[index]}
                              defaultChecked
                              onChange={() => handleCheckboxToggle(index)}
                            />
                            <span
                              style={{ textAlign: "center", display: "block" }}
                            >
                              {value.count}
                            </span>
                          </td>
                          <td
                            className="bet_probability_column"
                            style={{
                              textAlign: "center",
                              display: "block",
                              wordBreak: "break-word",
                            }}
                          >
                            {value.showNumber
                              ? value.showNumber.toString().replace(/,/g, " : ")
                              : value.angka}
                          </td>
                          {/* <td>{value.type}</td> */}
                          <td>
                            <p>
                              <span>
                                {/*formatPrice(value.taruhan)*/} 
                                {formatPrice(
                                (
                                  Number(value.taruhan || 0) -
                                  (Number(value.taruhan || 0) *
                                    Number(
                                      value.type.includes("4D")
                                        ? betDiscount?.showDisc4d
                                        : value.type.includes("3D")
                                        ? betDiscount?.showDisc3d
                                        : betDiscount?.showDisc2d
                                    )) /
                                    100
                                ) 
                              )}
                                
                              {" "}X{" "} 
                                {formatPrice(
                                  typeof value.showNumber != "undefined"
                                    ? value.showNumber.length
                                    : 1
                                )}{" "}
                                ={" "}
                              </span>
                              {/* {formatPrice(
                                parseInt(
                                  typeof value.showNumber != "undefined"
                                    ? value.showNumber.length
                                    : 1
                                ) * parseInt(value.taruhan)
                              )} */}
                              {formatPrice(
                                (
                                  Number(value.taruhan || 0) -
                                  (Number(value.taruhan || 0) *
                                    Number(
                                      value.type.includes("4D")
                                        ? betDiscount?.showDisc4d
                                        : value.type.includes("3D")
                                        ? betDiscount?.showDisc3d
                                        : betDiscount?.showDisc2d
                                    )) /
                                    100
                                ) *
                                  Number(
                                    typeof value.showNumber !== "undefined"
                                      ? value.showNumber.length
                                      : 1
                                  )
                              )}
                            </p>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <div className="betdiskon_total" ref={totaldiv}>
                <div className="d-flex flex-direction-column">
                  <div className="d-flex flex-direction-column total">
                    {/* <div className="data-submit">
                      {props.t("total_amount")}:
                      <span className="betdiskon_total_amount">
                        {formatPrice(totalAmount)}
                      </span>
                    </div>
                    <div className=" data-discount">
                      {props.t("discount")}:
                      <span className="betdiskon_total_discount">
                        -{formatPrice(parseFloat(discountAmount))}
                      </span>
                    </div> */}
                    <div className="total_pay">
                      {props.t("total")} {/*props.t("pay")*/} {" "}:
                      <span className="betdiskon_total_discount">
                        {formatPrice(parseFloat(payAmount))}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="last_div">
            <div className="left_div">
              <p>{props.t("guess_exact_number")}</p>
            </div>
            <div className="right_div" 
            ref={resetRef} 
            >
              <ul className="button-list" >
                {/* <li className={`reset-btx  ${currentStep === 6 ? "custom-tooltip-wrapper highlighted" : ""}`}> */}
                <li  className={`reset-btx custom-tooltip-wrapper`}
                  style={{
                    zIndex:
                      currentStep === 2 || currentStep === 3 || currentStep === 4 || currentStep === 5
                        ? 1
                        : "auto"
                  }
                  } 
                  >

                  <button
                    onClick={allDataReset}
                    // className={`reset`} 
                    className={`reset ${currentStep === 6 ? "disabled" : ""}`}
                    style={{ zIndex: currentStep === 6 ? 9 : "auto",

                          backgroundColor: [2, 3, 4, 5].includes(currentStep) ? "#451010" : "var(--red-btn)",
                              color: [2, 3, 4, 5].includes(currentStep) ? "#7b7977" : "#e8e6e3", // adjust default if needed
                     }}
                    disabled={currentStep === 6} // Disable the button
                  >
                    Reset
                  </button>
                  {currentStep === 6 && <CoachMarkPopup />}
                  {currentStep === 6 && <div className="custom-overlay" ></div>}
                </li>

                {mainButton ? (
                  <li className={`submit-btx custom-tooltip-wrapper `} 
                  style={{
                    zIndex:
                      currentStep === 2 || currentStep === 3 || currentStep === 4 || currentStep === 5
                        ? 1
                        : "auto", 

                  }}
                  >

                    <button
                      onClick={submitProcess}
                      // className={`submit`} 
                      className={`submit ${currentStep === 7 ? "disabled" : ""}`}
                      style={{ 
                        zIndex: currentStep === 7 ? 9 : "auto",
                          backgroundColor: [2, 3, 4, 5].includes(currentStep) && "#472818",
                          color: [2, 3, 4, 5].includes(currentStep) ? "#7b7977" : "#e8e6e3", // adjust default if needed

                       }}
                      disabled={currentStep === 7} // Disable the button

                    >
                      {props.t("submit")}
                    </button>
                    {currentStep === 7 && <CoachMarkPopup />}
                    {currentStep === 7 && <div className="custom-overlay"></div>}
                  </li>

                ) : (
                  <li>
                    <button onClick={submitProcessBB} className="submit">
                      {props.t("submit")}
                    </button>
                  </li>
                )

                }


              </ul>
            </div >
            {showConfirmationPopup && (
              <ConfirmBetDeskonPopup
                onClose={hanldeConfirmationPopupClose}
                message={succMessage}
                submitProcessOk={submitProcessOk}
              />
            )}
            {
              showCancelledPopup && (
                <CancelledBetDeskonPopup
                  onClose={() => setShowCancelledPopup(false)}
                />
              )
            }
            {
              showConfirmationDataPopup && (
                <ConfirmDataBetDeskonPopup
                  onClose={() => setShowConfirmationDataPopup(false)}
                  message={succMessage}
                  submitProcessOk={submitProcessOk}
                />
              )
            }
            {
              successPopup && (
                <div className="popup-overlay ">
                  <BetSuccessPopup
                    response={respData}
                    onClose={handlePopupClose}
                  />
                </div>
              )
            }
            {
              /*---error popup --*/
              showErrorPopup && (
                <ErrorInnerPopup
                  modalTitle={""}
                  modalHeader={true}
                  onCloseModal={() => setShowErrorPopup(false)}
                >
                  <ErrorPopup
                    message={errMessage}
                    onClose={() => setShowErrorPopup(false)}
                  />
                </ErrorInnerPopup>
              )
            }
          </div >
        </>
      )}
    </>
  );
};

export default withTranslation()(Bet_Diskon);
